

// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { IoArrowBackCircle } from 'react-icons/io5';
// import { useNavigate } from 'react-router-dom';
// import { FaEdit, FaTrashAlt } from 'react-icons/fa';
// import axios from 'axios';

// const QuestionnaireForm = () => {
//   const [questions, setQuestions] = useState([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '', time: 1 },]);
//   const [submittedQuestions, setSubmittedQuestions] = useState([]);
//   const [editingQuestionId, setEditingQuestionId] = useState(null);
//   const [showModal1, setShowModal1] = useState(false);
//   const [showQuizimg, setShowQuizimg] = useState(false)
//   const [user, setUser] = useState(null);
//   const [events, setEvents] = useState([]);



//   // --- Schedule Modal States ---
// const [showScheduleModal, setShowScheduleModal] = useState(false);
// const [scheduleDate, setScheduleDate] = useState('');
// const [scheduleTime, setScheduleTime] = useState('');
// const [scheduleTitle, setScheduleTitle] = useState('');
// const [createdSchedulePin, setCreatedSchedulePin] = useState(null);
// const [schedulingLoading, setSchedulingLoading] = useState(false);
// const [createdScheduleEventId, setCreatedScheduleEventId] = useState(null);

//   // --- Quota & Subscription Lock States ---
//   const [subStatus, setSubStatus] = useState(null);

//   const fetchSubStatus = async (userId) => {
//     try {
//       const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/subscription/current-status/${userId}`);
//       if (res.data?.success) {
//         setSubStatus(res.data);
//       }
//     } catch (err) {
//       console.error('Failed to load subscription status:', err);
//     }
//   };

//   useEffect(() => {
//     if (user?.id) {
//       fetchSubStatus(user.id);
//     }
//   }, [user]);


// // --- UNIFIED SUBSCRIPTION & EVENT LOCK LOGIC ---
//   const activeEvent = events.find((event) => event.flag === 1);
//   const isEventLocked = activeEvent?.is_locked === 1;

//   // 1. Subscription Check (Expired Trial, Expired Paid Plan, or Quota Exhausted)
//   const isSubscriptionLocked = (() => {
//     if (!subStatus) return false;
//     const isExpired = subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired';
//     const isExhausted = subStatus.quizzesRemaining <= 0;
//     return isExpired || isExhausted;
//   })();

//   // 2. Action Lock: Disable adding/editing/generating if subscription is locked OR event is completed/locked
//   const isActionDisabled = isSubscriptionLocked || isEventLocked;

//   // 3. Hosting/Scheduling Lock: If trial or paid plan is expired, lock hosting too!
//   const isHostingLocked = (() => {
//     if (!subStatus) return false;
//     return subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired';
//   })();

//   const getCombinedLockReason = () => {
//     if (isEventLocked) {
//       return 'Event Quiz Completed & Locked: Questions cannot be altered or added for this event.';
//     }
//     if (!subStatus) return '';
//     if (subStatus.planStatus === 'trial_expired') {
//       return '24-Hour Free Trial Expired: Upgrade your plan to edit or host quizzes.';
//     }
//     if (subStatus.planStatus === 'expired') {
//       return 'Subscription Expired: Please renew your plan to continue.';
//     }
//     if (subStatus.quizzesRemaining <= 0) {
//       return `Quota Reached: All ${subStatus.allowedQuizzes} Event Quizzes used. Upgrade or renew to add more.`;
//     }
//     return '';
//   };



//   const colors = {
//     orange: '#f35018',
//     blue: '#2f3194',
//     cyan: '#63decc',
//     textMain: '#0f1137',
//     glassWhite: 'rgba(255, 255, 255, 0.85)'
//   };

//   useEffect(() => {
//     const storedUser = sessionStorage.getItem('user');
//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     }
//   }, []);


//   useEffect(() => {
//     if (user && events.length > 0) {
//       fetchData();
//     }
//   }, [user, events]);

//   const fetchData = () => {
//     if (user && user.id) {
//       const activeEvent = events.find((event) => event.flag === 1);
//       const eventId = activeEvent ? activeEvent.id : null;
//       let url = `https://rvapi.emedha.in/pages/api/api/questions?userId=${user.id}`;
//       if (eventId) {
//         url += `&eventId=${eventId}`;
//       }
//       fetch(url)
//         .then((response) => response.json())
//         .then((data) => setSubmittedQuestions(data))
//         .catch((error) => console.error('Error fetching questions:', error));
//     }
//   };


//   const handleCreateSchedule = async (e) => {
//   e.preventDefault();
//   if (!scheduleDate || !scheduleTime) {
//     alert('Please select both Date and Time.');
//     return;
//   }

//   const activeEvent = events.find((event) => event.flag === 1);
//   const eventId = activeEvent ? activeEvent.id : null;

//   if (!eventId || !user?.id) {
//     alert('Active event or user session not found.');
//     return;
//   }

//   // Combine into MySQL DATETIME format (YYYY-MM-DD HH:MM:SS)
//   const scheduledAt = `${scheduleDate} ${scheduleTime}:00`;

//   try {
//     setSchedulingLoading(true);
//     const res = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/schedule-session', {
//       eventId,
//       userId: user.id,
//       scheduledAt,
//       title: scheduleTitle || activeEvent.name
//     });

//     if (res.data.success) {
//       setCreatedSchedulePin(res.data.roomPin);
//       setCreatedScheduleEventId(eventId)
//     }
//   } catch (err) {
//     console.error('Failed to schedule session:', err);
//     alert(err.response?.data?.error || 'Failed to schedule quiz.');
//   } finally {
//     setSchedulingLoading(false);
//   }
// };


//   const handleInputChange = (e, index, field, optionIndex = null) => {
//     const { value } = e.target;
//     setQuestions((prevQuestions) => {
//       const updatedQuestions = [...prevQuestions];
//       if (field === 'title') {
//         updatedQuestions[index].title = value;
//       } else if (field === 'question') {
//         updatedQuestions[index].question = value;
//       } else if (field === 'option') {
//         updatedQuestions[index].options[optionIndex] = value;
//       } else if (field === 'correctAnswer') {
//         updatedQuestions[index].correctAnswer = value;
//       } else if (field === 'correct_image') {
//         updatedQuestions[index].correct_image = value;
//       } else if (field === 'time') {
//         const parsedTime = parseInt(value, 10);
//         console.log('Time changed to:', parsedTime);
//         updatedQuestions[index].time = parsedTime;
//       }
//       return updatedQuestions;
//     });
//   };



//   const handleSubmit = (e) => {

//     const activeEvent = events.find((event) => event.flag === 1);
//     const eventId = activeEvent ? activeEvent.id : null;

//     console.log('Submitting time:', questions[0].time);
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append('title', questions[0].title);
//     formData.append('question', questions[0].question);
//     formData.append('correctAnswer', questions[0].correctAnswer);
//     formData.append('correct_image', questions[0].correct_image);
//     formData.append('userId', user ? user.id : null);
//     formData.append('time', questions[0].time);
//     formData.append('event_id', eventId);
//     questions[0].options.forEach((option, index) => {
//       formData.append(`options[${index}]`, option);
//     });
//     if (showQuizimg) {
//       for (let index = 0; index < 4; index++) {
//         const inputElement = document.querySelector(`#fileInput${index}`);
//         if (inputElement && inputElement.files.length > 0) {
//           formData.append('files', inputElement.files[0]);
//         }
//       }
//     }

//     const url = editingQuestionId
//       ? `https://rvapi.emedha.in/pages/api/api/questions/${editingQuestionId}`
//       : `https://rvapi.emedha.in/pages/api/api/questions`;

//     fetch(url, {
//       method: editingQuestionId ? 'PUT' : 'POST',
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.message === 'Question inserted successfully' || data.message === 'Question updated successfully') {
//           alert('Your question has been successfully submitted!');
//           fetchData();
//     if (user?.id) fetchSubStatus(user.id);
//         } else {
//           alert(data.message || 'There was an error submitting the question. Please try again.');
//         }
//         setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '', time: 1 }]);
//         setShowModal1(false);
//         setShowQuizimg(false);
//       })
//       .catch((error) => {
//         alert('Error submitting question: ' + error.message);
//         console.error('Error submitting question:', error);
//       });
//   };

//   const handleEdit = (questionId) => {
//     const questionToEdit = submittedQuestions.find((q) => q.id === questionId);
//     setEditingQuestionId(questionId);
//     setQuestions([
//       {
//         title: questionToEdit.title,
//         question: questionToEdit.question,
//         options: [
//           questionToEdit.option_1,
//           questionToEdit.option_2,
//           questionToEdit.option_3,
//           questionToEdit.option_4,
//         ],
//         correctAnswer: questionToEdit.correct_answer,
//         correct_image: questionToEdit.correct_image,
//         images1: questionToEdit.images1,
//         images2: questionToEdit.images2,
//         images3: questionToEdit.images3,
//         images4: questionToEdit.images4,
//         time: questionToEdit.time,
//       },
//     ]);


//     if (questionToEdit.images1 || questionToEdit.images2 || questionToEdit.images3 || questionToEdit.images4) {
//       setShowQuizimg(true);
//       setShowModal1(false);
//     } else {
//       setShowModal1(true);
//       setShowQuizimg(false);
//     }
//   };

//   const handleDelete = (questionId) => {
//     fetch(`https://rvapi.emedha.in/pages/api/api/questions/${questionId}`, {
//       method: 'DELETE',
//     }).then((response) => response.json())
//       .then(() => {
//         setSubmittedQuestions((prevQuestions) =>
//           prevQuestions.filter((q) => q.id !== questionId)
//         );
//       })
//       .catch((error) => console.error('Error deleting question:', error));
//   };
//   const navigate = useNavigate();
//   const handleBack = () => { navigate(-1); };


//   const handleGenerateUrl = () => {
//     const randomString = Math.random().toString(36).substring(2, 100);
//     navigate(`/QuestionsList/${user.id}/${randomString}/QuestionsList`);
//   };
//   const handleWithoutGenerateUrl = () => {
//     const randomString = Math.random().toString(36).substring(2, 100);
//     navigate(`/QuestionsList/${user.id}/${randomString}/QuestionsList1`);
//   };


//   // Updated Host Live Room launcher engine
//   // const handleLaunchLiveSession = (requiresCertificate) => {
//   //   if (!user || !user.id) {
//   //     alert("Session expired. Please log in again.");
//   //     return;
//   //   }

//   //   // Identify the active event profile
//   //   const activeEvent = events.find((event) => event.flag === 1);
//   //   const eventId = activeEvent ? activeEvent.id : 'no-event';

//   //   // Generate a secure, unique 6-digit numeric game PIN
//   //   const generatedPin = Math.floor(100000 + Math.random() * 900000).toString();

//   //   // Create the exact direct link your participants will scan to join
//   //   const participantJoinUrl = `${window.location.origin}/join?pin=${generatedPin}&eventId=${eventId}`;

//   //   // Pass the parameters cleanly via React Router State to the Host view
//   //   navigate(`/HostLiveRoom/${generatedPin}`, {
//   //     state: {
//   //       pin: generatedPin,
//   //       eventId: eventId,
//   //       joinUrl: participantJoinUrl,
//   //       certMode: requiresCertificate,
//   //       userId: user.id
//   //     }
//   //   });
//   // };


//   const handleLaunchLiveSession = async (requiresCertificate) => {
//   if (!user || !user.id) {
//     alert("Session expired. Please log in again.");
//     return;
//   }

//   // 1. Identify active event
//   const activeEvent = events.find((event) => event.flag === 1);
//   const eventId = activeEvent ? activeEvent.id : null;

//   if (!eventId) {
//     alert("No active event selected at the header layer.");
//     return;
//   }

//   // 2. Generate the unique 6-digit PIN
//   const generatedPin = Math.floor(100000 + Math.random() * 900000).toString();
//   const participantJoinUrl = `${window.location.origin}/join?pin=${generatedPin}&eventId=${eventId}`;

//   try {
//     // 3. HIT BACKEND API TO WRITE PIN TO quiz_active_sessions TABLE
//     const response = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/create-session', {
//       roomPin: generatedPin,
//       eventId: eventId,
//       userId: user.id
//     });

//     if (response.data.success) {
//       // 4. Navigate only if database write was successful
//       navigate(`/HostLiveRoom/${generatedPin}`, {
//         state: {
//           pin: generatedPin,
//           eventId: eventId,
//           joinUrl: participantJoinUrl,
//           certMode: requiresCertificate,
//           userId: user.id
//         }
//       });
//     }
//   } catch (error) {
//     console.error("API error establishing room:", error);
//     alert("Failed to initialize the live database room. Try again.");
//   }
// };

//   useEffect(() => {
//     const storedUser = sessionStorage.getItem('user');
//     if (storedUser) {
//       const parsedUser = JSON.parse(storedUser);
//       setUser(parsedUser);
//     } else {
//       console.log('No user data found in session storage');
//     }
//   }, []);

//   useEffect(() => {
//     if (user && user.id) {
//       fetchEvents();
//     } else {
//       console.log('User is missing or incomplete');
//     }
//   }, [user]);
//   const fetchEvents = async () => {
//     if (!user || !user.id) {
//       console.error('User ID is missing');
//       return;
//     }
//     try {
//       const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
//       setEvents(response.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   const [currentPage, setCurrentPage] = useState(1);
//   const questionsPerPage = 10;
//   const indexOfLastQuestion = currentPage * questionsPerPage;
//   const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
//   const currentQuestions = submittedQuestions.slice(indexOfFirstQuestion, indexOfLastQuestion);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // Generate gpt

//   const [topicx, setTopicx] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [numQuestions, setNumQuestions] = useState(5);

//   const handleGenerateQuiz = async () => {
//     setLoading(true);
//     try {
//       if (!user) {
//         console.error('User not found or not logged in');
//         return;
//       }
//       if (!topicx.trim()) {
//         console.error('Topic is empty');
//         return;
//       }
//       const activeEvent = events.find((event) => event.flag === 1);
//       const eventId = activeEvent ? activeEvent.id : null;

//       const response = await axios.post('https://rvapi.emedha.in/pages/api/generate-quiz', {
//         prompt: topicx,
//         numberOfQuestions: numQuestions,
//         model: 'text-davinci-003',
//         max_tokens: 300,
//         user: user.id,
//         event_id: eventId,
//       });

//       const data = response.data;
//       console.log('API Response:', data);
//       const questionData = data.questionsx || [];
//       const parsedQuestions = questionData
//         .filter(q => q.question.trim() !== '')
//         .map((q, index) => ({
//           question: q.question,
//           options: q.options || ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
//           correctAnswer: q.correctAnswer || 'A',
//         }));
//       setSubmittedQuestions(parsedQuestions);
//       fetchData();
//       if (user?.id) fetchSubStatus(user.id);
//     }  catch (error) {
//       console.error('Error generating quiz:', error);
//       alert(error.response?.data?.message || error.response?.data || 'Failed to generate quiz. Check your plan quota.');
//     } finally {
//       setLoading(false);
//     }
//   };



//   // Check if active event is locked from a completed podium
//   // const isEventLocked = activeEvent?.is_locked === 1;

//   // // Combine creation restrictions: either plan limit exhausted OR this event completed the podium
//   // const isActionDisabled = isCreationLocked || isEventLocked;

//   // const getCombinedLockReason = () => {
//   //   if (isEventLocked) {
//   //     return 'This event quiz has completed its live run and is locked. You can still host it live, but questions cannot be altered. Create a new event to add a new quiz.';
//   //   }
//   //   return getLockReason();
//   // };



//   return (
//     <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', fontSize: '12px', background: '#eaf3fcff', }}>

//     <div style={{ 
//       background: 'linear-gradient(135deg, #f4f5fc 0%, #eef0fa 100%)', 
//       fontFamily: '"Plus Jakarta Sans", "Poppins", sans-serif', 
//       padding: '10px 10px', 
//       fontSize: '12px',

//       color: colors.textMain
//     }}>
      
//       {/* LUXURY DYNAMIC EVENT HEADER */}
//       <div className="header mb-4" style={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         padding: '16px 24px', 
//         backgroundColor: colors.glassWhite,
//         backdropFilter: 'blur(20px)',
//         borderRadius: '16px', 
//         border: '1px solid rgba(255, 255, 255, 0.7)',
//         boxShadow: '0 10px 30px rgba(15, 17, 55, 0.03)', 
//       }}>
//    <div
//   className="d-flex align-items-center position-relative"
//   style={{ width: "100%" }}
// >
//   <div
//     style={{
//       padding: "2px",
//       background: `linear-gradient(135deg, ${colors.blue}, ${colors.cyan})`,
//       borderRadius: "8px",
//       zIndex: 2,
//     }}
//   >
//     <img
//       src={events.find((event) => event.flag === 1)?.file || ""}
//       alt="Logo"
//       style={{
//         width: "56px",
//         height: "56px",
//         objectFit: "contain",
//         borderRadius: "6px",
//         backgroundColor: "#fff",
//       }}
//     />
//   </div>

//   <h2
//     className="mb-0 fw-bold text-truncate"
//     style={{
//       position: "absolute",
//       left: "50%",
//       transform: "translateX(-50%)",
//       color: colors.white,
//       fontSize: "25px",
//       letterSpacing: "0.2px",
//       textAlign: "center",
//       width: "100%",
//       pointerEvents: "none",
//     }}
//   >
//     {events && events.length > 0
//       ? events.find((e) => e.flag === 1)?.name
//       : "No active session"}
//   </h2>
// </div>
//       </div>


//       {/* LUXURY ACTION CONTROL MATRIX */}
//       <div className="mb-1 p-4" style={{ 
//         backgroundColor: '#ffffff', 
//         borderRadius: '20px',
//         boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)',
//         border: '1px solid rgba(47, 49, 148, 0.05)'
//       }}>
//         <div className="container-fluid p-0">
//           <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
            
//             {/* Back Navigation Title */}
//             <div className="d-flex align-items-center gap-2">
//               <IoArrowBackCircle 
//                 onClick={handleBack} 
//                 style={{ cursor: 'pointer', fontSize: '2.2rem', color: colors.blue, transition: 'all 0.2s ease' }} 
//                 onMouseEnter={(e) => e.currentTarget.style.color = colors.orange}
//                 onMouseLeave={(e) => e.currentTarget.style.color = colors.blue}
//               />
//               <div>
//                 <h4 className="m-0 fw-bold" style={{ color: colors.blue, letterSpacing: '-0.5px' }}>Quiz Management</h4>
//                 <p className="text-muted mb-0" style={{ fontSize: '11px' }}>Build custom question banks or leverage AI setups.</p>
//               </div>
//             </div>
            
//             {/* Premium Button Suite */}
//             {/* <div className="d-flex flex-wrap gap-2 justify-content-center">
           

//               <button 
//                 className="btn btn-sm fw-bold px-3 py-2 transition-all" 
//                 onClick={(e) => { 
//                   e.preventDefault(); 
//                   if (isCreationLocked) {
//                     alert(getLockReason());
//                     return;
//                   }
//                   setShowModal1(true); 
//                   setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
//                 }} 
//                 disabled={isCreationLocked}
//                 style={{ 
//                   borderRadius: '10px', 
//                   backgroundColor: isCreationLocked ? '#9ca3af' : colors.blue, 
//                   color: '#fff', 
//                   border: 'none', 
//                   boxShadow: isCreationLocked ? 'none' : '0 4px 12px rgba(47,49,148,0.15)',
//                   cursor: isCreationLocked ? 'not-allowed' : 'pointer',
//                   opacity: isCreationLocked ? 0.65 : 1
//                 }}
//                 title={isCreationLocked ? getLockReason() : "Add Quiz"}
//               >
//                 + Add Quiz
//               </button>


//               <button 
//                 className="btn btn-sm fw-bold px-3 py-2 transition-all" 
//                 onClick={(e) => { 
//                   e.preventDefault(); 
//                   if (isCreationLocked) {
//                     alert(getLockReason());
//                     return;
//                   }
//                   setShowQuizimg(true); 
//                   setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
//                 }} 
//                 disabled={isCreationLocked}
//                 style={{ 
//                   borderRadius: '10px', 
//                   backgroundColor: '#ffffff', 
//                   color: isCreationLocked ? '#9ca3af' : colors.blue, 
//                   border: `1px solid ${isCreationLocked ? '#d1d5db' : 'rgba(47,49,148,0.15)'}`, 
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.02)',
//                   cursor: isCreationLocked ? 'not-allowed' : 'pointer',
//                   opacity: isCreationLocked ? 0.65 : 1
//                 }}
//                 title={isCreationLocked ? getLockReason() : "Add Images Quiz"}
//               >
//                 + Add Images Quiz
//               </button>
// <button 
//   className="btn btn-sm fw-bold px-3 py-2 transition-all" 
//   onClick={() => handleLaunchLiveSession(false)} 
//   style={{ borderRadius: '10px', backgroundColor: 'rgba(15, 17, 55, 0.05)', color: colors.textMain, border: 'none' }}
// >
//   🎮 Host Live 
// </button>


// <button 
//   className="btn btn-sm fw-bold px-3 py-2 transition-all" 
//   onClick={() => {
//     setCreatedSchedulePin(null);
//     setScheduleDate('');
//     setScheduleTime('');
//     setScheduleTitle('');
//     setShowScheduleModal(true);
//   }} 
//   style={{ 
//     borderRadius: '10px', 
//     backgroundColor: '#ffffff', 
//     color: colors.blue, 
//     border: `1.5px solid ${colors.blue}`,
//     boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
//   }}
// >
//   📅 Schedule Quiz
// </button>

// {/* <button 
//   className="btn btn-sm fw-bold px-3 py-2 transition-all" 
//   onClick={() => handleLaunchLiveSession(true)} 
//   style={{ borderRadius: '10px', background: `linear-gradient(135deg, ${colors.orange}, #ff7342)`, color: '#fff', border: 'none', boxShadow: '0 4px 12px rgba(243,80,24,0.15)' }}
// >
//   🏆 Host Live (With Cert)
// </button>
   
//          </div>  */}

// <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center">
              
//               {/* Event Locked Indicator Badge */}
//               {isEventLocked && (
//                 <span className="badge bg-danger px-3 py-2 rounded-pill me-1" style={{ fontSize: '11px' }}>
//                   🔒 Event Locked (Podium Finished)
//                 </span>
//               )}

//               {/* 1. Add Quiz */}
//               <button 
//                 className="btn btn-sm fw-bold px-3 py-2" 
//                 onClick={(e) => { 
//                   e.preventDefault(); 
//                   if (isActionDisabled) {
//                     alert(getCombinedLockReason());
//                     return;
//                   }
//                   setShowModal1(true); 
//                   setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
//                 }} 
//                 disabled={isActionDisabled}
//                 style={{ 
//                   borderRadius: '10px', 
//                   backgroundColor: isActionDisabled ? '#9ca3af' : colors.blue, 
//                   color: '#fff', 
//                   border: 'none', 
//                   cursor: isActionDisabled ? 'not-allowed' : 'pointer',
//                   opacity: isActionDisabled ? 0.65 : 1
//                 }}
//                 title={isActionDisabled ? getCombinedLockReason() : "Add Quiz"}
//               >
//                 + Add Quiz
//               </button>

//               {/* 2. Add Images Quiz */}
//               <button 
//                 className="btn btn-sm fw-bold px-3 py-2" 
//                 onClick={(e) => { 
//                   e.preventDefault(); 
//                   if (isActionDisabled) {
//                     alert(getCombinedLockReason());
//                     return;
//                   }
//                   setShowQuizimg(true); 
//                   setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
//                 }} 
//                 disabled={isActionDisabled}
//                 style={{ 
//                   borderRadius: '10px', 
//                   backgroundColor: '#ffffff', 
//                   color: isActionDisabled ? '#9ca3af' : colors.blue, 
//                   border: `1px solid ${isActionDisabled ? '#d1d5db' : 'rgba(47,49,148,0.15)'}`, 
//                   cursor: isActionDisabled ? 'not-allowed' : 'pointer',
//                   opacity: isActionDisabled ? 0.65 : 1
//                 }}
//                 title={isActionDisabled ? getCombinedLockReason() : "Add Images Quiz"}
//               >
//                 + Add Images Quiz
//               </button>

//               {/* 3. Host Live Button */}
//               <button 
//                 className="btn btn-sm fw-bold px-3 py-2" 
//                 onClick={() => {
//                   if (isHostingLocked) {
//                     alert(getCombinedLockReason());
//                     return;
//                   }
//                   handleLaunchLiveSession(false);
//                 }} 
//                 disabled={isHostingLocked}
//                 style={{ 
//                   borderRadius: '10px', 
//                   backgroundColor: isHostingLocked ? '#9ca3af' : 'rgba(15, 17, 55, 0.05)', 
//                   color: isHostingLocked ? '#ffffff' : colors.textMain, 
//                   border: 'none',
//                   cursor: isHostingLocked ? 'not-allowed' : 'pointer',
//                   opacity: isHostingLocked ? 0.65 : 1
//                 }}
//                 title={isHostingLocked ? getCombinedLockReason() : "Host Live"}
//               >
//                 🎮 Host Live 
//               </button>

//               {/* 4. Schedule Quiz Button */}
//               <button 
//                 className="btn btn-sm fw-bold px-3 py-2" 
//                 onClick={() => {
//                   if (isHostingLocked) {
//                     alert(getCombinedLockReason());
//                     return;
//                   }
//                   setCreatedSchedulePin(null);
//                   setCreatedScheduleEventId(null);
//                   setScheduleDate('');
//                   setScheduleTime('');
//                   setScheduleTitle('');
//                   setShowScheduleModal(true);
//                 }} 
//                 disabled={isHostingLocked}
//                 style={{ 
//                   borderRadius: '10px', 
//                   backgroundColor: '#ffffff', 
//                   color: isHostingLocked ? '#9ca3af' : colors.blue, 
//                   border: `1.5px solid ${isHostingLocked ? '#d1d5db' : colors.blue}`,
//                   cursor: isHostingLocked ? 'not-allowed' : 'pointer',
//                   opacity: isHostingLocked ? 0.65 : 1
//                 }}
//                 title={isHostingLocked ? getCombinedLockReason() : "Schedule Quiz"}
//               >
//                 📅 Schedule Quiz
//               </button>

//             </div>


//           </div>
//         </div>
//       </div>
//       </div>
//      {/* LUXURY GENERATIVE AI CAPABILITY SECTION */}
//       <div className="text-center mb-2" style={{  padding: '10px 10px', }}>
//         <div className="d-flex mb-3 gap-3 flex-wrap align-items-center justify-content-center" style={{ 
//           borderRadius: '24px', 
//           backgroundColor: '#ffffff', 
//           padding: '24px',
//           boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)',
//           border: '1px solid rgba(47, 49, 148, 0.05)'
//         }}>
          
//           {/* AI Topic input wrapper */}
//           <div className="col-12 col-md-5">
//             <label className="d-block text-start mb-2 fw-bold text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>
//               AI GENERATION TOPIC
//             </label>
//             <input 
//               type="text" 
//               className="form-control px-3 py-2" 
//               value={topicx} 
//               onChange={(e) => setTopicx(e.target.value)} 
//               placeholder="Enter a topic (e.g., General Knowledge, Science)" 
//               style={{ 
//                 borderRadius: '12px', 
//                 fontSize: '13px', 
//                 border: '1px solid rgba(47, 49, 148, 0.12)', 
//                 backgroundColor: '#f8f9fc',
//                 color: colors.textMain
//               }} 
//             />
//           </div>

//           {/* Number of questions input wrapper */}
//           <div className="col-12 col-md-3">
//             <label className="d-block text-start mb-2 fw-bold text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>
//               QUESTION QUANTITY
//             </label>
//             <input 
//               type="number" 
//               className="form-control px-3 py-2" 
//               value={numQuestions} 
//               min={1} 
//               max={50} 
//               onChange={(e) => setNumQuestions(Number(e.target.value))} 
//               placeholder="Number of questions" 
//               style={{ 
//                 borderRadius: '12px', 
//                 fontSize: '13px', 
//                 border: '1px solid rgba(47, 49, 148, 0.12)', 
//                 backgroundColor: '#f8f9fc',
//                 color: colors.textMain
//               }} 
//             />
//           </div>

//           {/* Interactive action trigger button */}
//           <div className="col-12 col-md-3 d-grid pt-md-4">
//             {/* <button 
//               className="btn fw-bold py-2 shadow-sm transition-all" 
//               onClick={handleGenerateQuiz} 
//               disabled={loading || !topicx.trim()} 
//               style={{ 
//                 borderRadius: '12px',
//                 background: loading ? '#6c757d' : `linear-gradient(135deg, ${colors.blue}, #4447ab)`,
//                 color: '#fff',
//                 border: 'none',
//                 fontSize: '13px',
//                 cursor: loading || !topicx.trim() ? 'not-allowed' : 'pointer',
//                 boxShadow: '0 4px 12px rgba(47, 49, 148, 0.15)'
//               }}
//             >
//               {loading ? 'Generating Dynamic Assets...' : '✨ Generate AI Quiz'}
//             </button> */}

//          <button 
//               className="btn fw-bold py-2 shadow-sm" 
//               onClick={() => {
//                 if (isActionDisabled) {
//                   alert(getCombinedLockReason());
//                   return;
//                 }
//                 handleGenerateQuiz();
//               }} 
//               disabled={loading || !topicx.trim() || isActionDisabled} 
//               style={{ 
//                 borderRadius: '12px',
//                 background: (loading || isActionDisabled) ? '#9ca3af' : `linear-gradient(135deg, ${colors.blue}, #4447ab)`,
//                 color: '#fff',
//                 border: 'none',
//                 fontSize: '13px',
//                 cursor: (loading || !topicx.trim() || isActionDisabled) ? 'not-allowed' : 'pointer',
//                 opacity: isActionDisabled ? 0.65 : 1
//               }}
//               title={isActionDisabled ? getCombinedLockReason() : "Generate AI Quiz"}
//             >
//               {loading 
//                 ? 'Generating Dynamic Assets...' 
//                 : isEventLocked 
//                 ? '🔒 Event Completed & Locked' 
//                 : isSubscriptionLocked 
//                 ? '🔒 Quota Reached / Plan Expired' 
//                 : '✨ Generate AI Quiz'}
//             </button>
//           </div>

//         </div>
//       </div>


//       <form onSubmit={handleSubmit}>
//         {showModal1 && (
//           <div className="modal" style={{ display: 'block', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)', fontSize: '10px', }}>
//             <div className="modal-content" style={{ maxWidth: '600px', margin: '100px auto', backgroundColor: 'white', padding: '15px', borderRadius: '6px', }}>
//               <div>
//                 {questions.map((question, index) => (
//                   <div key={index} className="mb-3">
//                     <div className="row mb-2">
//                       <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Title:</label>
//                       <div className="col-12">
//                         <input type="text" value={question.title} onChange={(e) => handleInputChange(e, index, 'title')} placeholder="Enter your title" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                       </div>
//                     </div>

//                     <div className="row mb-2">
//                       <div className="col-6">
//                         <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Question:</label>
//                         <input type="text" value={question.question} onChange={(e) => handleInputChange(e, index, 'question')} placeholder="Enter your question" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                       </div>
//                       <div className="col-6">
//                         <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Time (in minutes):</label>
//                         <select required value={question.time || 1} onChange={(e) => handleInputChange(e, index, 'time')} style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }}>
//                           {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
//                             <option key={minute} value={minute}>
//                               {minute} minute{minute > 1 ? 's' : ''}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>

//                     <div className="mb-2">
//                       <label className="form-label" style={{ fontWeight: '600', color: '#333', marginBottom: '4px' }}>Options:</label>
//                       <div className="row">
//                         {question.options.map((option, optionIndex) => (
//                           <div key={optionIndex} className="col-12 col-md-6 mb-2">
//                             <input type="text" value={option} onChange={(e) => handleInputChange(e, index, 'option', optionIndex)} placeholder={`Option ${String.fromCharCode(65 + optionIndex)}`} required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                           </div>
//                         ))}
//                       </div>
//                     </div>

//                     <div className="row mb-3">
//                       <label className="col-12 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Correct Answer:</label>
//                       <div className="col-12">
//                         <input type="text" value={question.correctAnswer} onChange={(e) => handleInputChange(e, index, 'correctAnswer')} placeholder="Enter correct answer" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//                 <button type="submit" style={{ backgroundColor: '#28a745', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', marginBottom: '6px', }}>Submit</button>
//                 <button type="button" onClick={() => setShowModal1(false)} style={{ backgroundColor: '#dc3545', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', }}>Close</button>
//               </div>
//             </div>
//           </div>
//         )}
//       </form>


//       <form onSubmit={handleSubmit}>
//         {showQuizimg && (
//           <div className="modal" style={{ display: 'block', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)', fontSize: '10px', }}>
//             <div className="modal-content" style={{ maxWidth: '600px', margin: '100px auto', backgroundColor: 'white', padding: '15px', borderRadius: '6px', }}>
//               <div>
//                 {questions.map((question, index) => (
//                   <div key={index} className="mb-3">
//                     <div className="row mb-2">
//                       <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}                   >Title:</label>
//                       <div className="col-12">
//                         <input type="text" value={question.title} onChange={(e) => handleInputChange(e, index, 'title')} placeholder="Enter your title" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                       </div>
//                     </div>

//                     <div className="row mb-2">
//                       <div className="col-6">
//                         <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Question:</label>
//                         <input type="text" value={question.question} onChange={(e) => handleInputChange(e, index, 'question')} placeholder="Enter your question" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                       </div>
//                       <div className="col-6">
//                         <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Time (in minutes):</label>
//                         <select required value={question.time || ''} onChange={(e) => handleInputChange(e, index, 'time')} style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }}>
//                           {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
//                             <option key={minute} value={minute}>
//                               {minute} minute{minute > 1 ? 's' : ''}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>

//                     <div className="mb-2">
//                       <label className="form-label" style={{ fontWeight: '600', marginBottom: '4px', color: '#333' }}>Options:</label>
//                       <div className="row">
//                         {question.options.map((option, optionIndex) => (
//                           <div key={optionIndex} className="col-12 col-md-6 mb-2">
//                             <label htmlFor={`fileInput${optionIndex}`} style={{ fontWeight: '500', color: '#333', fontSize: '12px' }}> {optionIndex + 1}.</label>
//                             <input type="file" id={`fileInput${optionIndex}`} style={{ width: '100%', padding: '6px 8px', marginTop: '4px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                             {question[`images${optionIndex + 1}`] && (
//                               <div>
//                                 <img src={question[`images${optionIndex + 1}`]} alt={`Option ${String.fromCharCode(65 + optionIndex)}`} style={{ height: '50px', marginTop: '6px' }} />
//                               </div>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                     </div>

//                     <div className="row mb-3">
//                       <label className="col-12 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Correct Answer Image No:</label>
//                       <div className="col-12">
//                         <input type="number" value={question.correct_image} onChange={(e) => handleInputChange(e, index, 'correct_image')} placeholder="Enter correct image No" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
//                         {question.correct_image && (
//                           <div><img src={question.correct_image} alt="Correct answer image" style={{ width: '100px', height: 'auto', marginTop: '6px' }} /></div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//                 <button type="submit" style={{ backgroundColor: '#28a745', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', marginBottom: '6px', }}>Submit</button>
//                 <button type="button" onClick={() => setShowQuizimg(false)} style={{ backgroundColor: '#dc3545', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', }}                >Close</button>
//               </div>
//             </div>
//           </div>
//         )}
//       </form>

// {/* 
//       <div className="mt-2">
//         <div style={{ background: '#fff', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '25px' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
//             <thead>
//               <tr style={{ background: '#f5f5f5' }}>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>#</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Title</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Question</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Options</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Correct Answer</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {submittedQuestions.map((question, index) => (
//                 <tr key={index}>
//                   <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{index + 1}</td>
//                   <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{question.title}</td>
//                   <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{question.question}</td>
//                   <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                     {['option_1', 'option_2', 'option_3', 'option_4'].map((optionKey, optionIndex) => {
//                       const imageKey = `images${optionIndex + 1}`;
//                       const imageUrl = question[imageKey];

//                       if (imageUrl) {
//                         return (
//                           <div key={optionIndex} className="mb-1">
//                             <img src={imageUrl} style={{ height: '50px', maxWidth: '100%' }} alt={`Option ${String.fromCharCode(65 + optionIndex)}`} />
//                           </div>
//                         );
//                       } else if (question[optionKey]) {
//                         return (
//                           <div key={optionIndex} className="mb-1">
//                             {String.fromCharCode(65 + optionIndex)}. {question[optionKey]}
//                           </div>
//                         );
//                       }
//                       return null;
//                     })}
//                   </td>

//                   <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                     {question.correct_answer && <div>{question.correct_answer}</div>}
//                     {question.correct_image && (
//                       <div> <img src={question.correct_image} alt="Correct answer image" style={{ width: '100px', height: 'auto', maxWidth: '100%' }} /></div>
//                     )}
//                   </td>

//                   <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                     <button onClick={() => handleEdit(question.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaEdit /></button>
//                     <button onClick={() => handleDelete(question.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaTrashAlt /></button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>


//       <div className="pagination" style={{ textAlign: 'center', marginTop: '20px', marginBottom: '80px' }}>
//         <button className="btn btn-secondary btn-sm" onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)} disabled={currentPage === 1}>Previous</button>
//         <span style={{ margin: '0 10px' }}>Page {currentPage} of {Math.ceil(submittedQuestions.length / questionsPerPage)}</span>
//         <button className="btn btn-secondary btn-sm" onClick={() => paginate(currentPage < Math.ceil(submittedQuestions.length / questionsPerPage) ? currentPage + 1 : currentPage)} disabled={currentPage === Math.ceil(submittedQuestions.length / questionsPerPage)}>Next</button>
//       </div> */}
//       {/* LUXURY RESPONSIVE DATA TABLE CONTAINER */}
//       <div className="mt-4">
//         <div style={{ 
//           background: '#ffffff', 
//           padding: '24px', 
//           boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)', 
//           borderRadius: '20px',
//           border: '1px solid rgba(47, 49, 148, 0.05)',
//           marginBottom: '30px' 
//         }}>
          
//           {/* Table Header Metrics */}
//           <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
//             <h5 className="fw-bold mb-0" style={{ color: colors.blue, fontSize: '16px', letterSpacing: '-0.3px' }}>
//               Submitted Question Bank ({submittedQuestions.length})
//             </h5>
//             <span className="badge px-3 py-2 rounded-pill" style={{ backgroundColor: 'rgba(47,49,148,0.06)', color: colors.blue, fontSize: '11px', fontWeight: '600' }}>
//               Active Track Records
//             </span>
//           </div>

//           {/* Responsive Table Wrapper */}
//           <div className="table-responsive">
//             <table className="table table-borderless align-middle mb-0" style={{ fontSize: '13px', minWidth: '800px' }}>
//               <thead>
//                 <tr style={{ background: '#f8f9fc', borderRadius: '12px' }}>
//                   <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', width: '5%' }}>#</th>
//                   <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '15%' }}>Title</th>
//                   <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '30%' }}>Question</th>
//                   <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '25%' }}>Options Configuration</th>
//                   <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '15%' }}>Target Answer</th>
//                   <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', borderTopRightRadius: '12px', borderBottomRightRadius: '12px', width: '10%', textAlign: 'center' }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentQuestions.map((question, index) => (
//                   <tr key={index} style={{ borderBottom: '1px solid rgba(15, 17, 55, 0.04)' }}>
//                     <td style={{ padding: '16px 10px', fontWeight: '600', color: colors.blue }}>
//                       {indexOfFirstQuestion + index + 1}
//                     </td>
//                     <td style={{ padding: '16px 10px', fontWeight: '600', color: colors.textMain }}>
//                       {question.title}
//                     </td>
//                     <td style={{ padding: '16px 10px', color: '#4a4d6d', lineHeight: '1.5' }}>
//                       {question.question}
//                     </td>
//                     <td style={{ padding: '16px 10px' }}>
//                       <div className="d-flex flex-column gap-1">
//                         {['option_1', 'option_2', 'option_3', 'option_4'].map((optionKey, optionIndex) => {
//                           const imageKey = `images${optionIndex + 1}`;
//                           const imageUrl = question[imageKey];

//                           if (imageUrl) {
//                             return (
//                               <div key={optionIndex} className="d-inline-block p-1 bg-light rounded" style={{ maxWidth: 'fit-content' }}>
//                                 <img src={imageUrl} style={{ height: '38px', borderRadius: '4px', objectFit: 'contain' }} alt={`Opt ${String.fromCharCode(65 + optionIndex)}`} />
//                               </div>
//                             );
//                           } else if (question[optionKey]) {
//                             return (
//                               <div key={optionIndex} style={{ color: '#555875', fontSize: '12px' }}>
//                                 <strong style={{ color: colors.orange }}>{String.fromCharCode(65 + optionIndex)}:</strong> {question[optionKey]}
//                               </div>
//                             );
//                           }
//                           return null;
//                         })}
//                       </div>
//                     </td>
//                     <td style={{ padding: '16px 10px' }}>
//                       {question.correct_answer && (
//                         <span className="badge px-2 py-1 rounded" style={{ backgroundColor: 'rgba(40, 167, 69, 0.1)', color: '#28a745', fontWeight: '600' }}>
//                           {question.correct_answer}
//                         </span>
//                       )}
//                       {question.correct_image && (
//                         <div className="mt-1 p-1 d-inline-block bg-light rounded"> 
//                           <img src={question.correct_image} alt="Correct target vector" style={{ width: '60px', height: 'auto', borderRadius: '4px' }} />
//                         </div>
//                       )}
//                     </td>
//                     {/*   <td style={{ padding: '16px 10px', textAlign: 'center' }}>
//                       <div className="d-flex justify-content-center gap-2">
//                         <button 
//                           onClick={() => handleEdit(question.id)} 
//                           className="btn p-2 rounded-3 d-flex align-items-center justify-content-center transition-all"
//                           style={{ background: 'rgba(47, 49, 148, 0.05)', border: 'none', color: colors.blue }}
//                           onMouseEnter={(e) => { e.currentTarget.style.background = colors.blue; e.currentTarget.style.color = '#fff'; }}
//                           onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(47, 49, 148, 0.05)'; e.currentTarget.style.color = colors.blue; }}
//                         >
//                           <FaEdit size={14} />
//                         </button>
//                       <button 
//                           onClick={() => handleDelete(question.id)} 
//                           className="btn p-2 rounded-3 d-flex align-items-center justify-content-center transition-all"
//                           style={{ background: 'rgba(243, 80, 24, 0.05)', border: 'none', color: colors.orange }}
//                           onMouseEnter={(e) => { e.currentTarget.style.background = colors.orange; e.currentTarget.style.color = '#fff'; }}
//                           onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(243, 80, 24, 0.05)'; e.currentTarget.style.color = colors.orange; }}
//                         >
//                           <FaTrashAlt size={14} />
//                         </button> 
//                       </div>
//                     </td>*/}
//                     <td style={{ padding: '16px 10px', textAlign: 'center' }}>
//                       <div className="d-flex justify-content-center gap-2">
//                         <button 
//                           onClick={() => {
//                             if (isEventLocked) {
//                               alert("This event is locked because its quiz has already finished.");
//                               return;
//                             }
//                             handleEdit(question.id);
//                           }} 
//                           disabled={isEventLocked}
//                           className="btn p-2 rounded-3 d-flex align-items-center justify-content-center"
//                           style={{ 
//                             background: 'rgba(47, 49, 148, 0.05)', 
//                             border: 'none', 
//                             color: isEventLocked ? '#9ca3af' : colors.blue,
//                             cursor: isEventLocked ? 'not-allowed' : 'pointer',
//                             opacity: isEventLocked ? 0.5 : 1
//                           }}
//                           title={isEventLocked ? "Event is locked" : "Edit Question"}
//                         >
//                           <FaEdit size={14} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//         </div>
//       </div>

//       {/* LUXURY INTERACTIVE PAGINATION CONTROLLER */}
//       <div className="pagination d-flex align-items-center justify-content-center gap-3" style={{ marginTop: '10px', marginBottom: '100px' }}>
//         <button 
//           className="btn fw-bold px-3 py-2 d-flex align-items-center justify-content-center transition-all" 
//           onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)} 
//           disabled={currentPage === 1}
//           style={{ 
//             borderRadius: '10px', 
//             backgroundColor: currentPage === 1 ? '#e9ecef' : '#ffffff', 
//             color: currentPage === 1 ? '#adb5bd' : colors.blue, 
//             border: '1px solid rgba(47, 49, 148, 0.08)',
//             fontSize: '12px',
//             cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
//             boxShadow: currentPage === 1 ? 'none' : '0 4px 12px rgba(0,0,0,0.02)'
//           }}
//         >
//           Previous
//         </button>
        
//         <span className="fw-semibold px-3 py-2 rounded-3" style={{ fontSize: '13px', backgroundColor: colors.glassWhite, color: colors.textMain, border: '1px solid rgba(47, 49, 148, 0.05)' }}>
//           Page <strong style={{ color: colors.orange }}>{currentPage}</strong> of {Math.ceil(submittedQuestions.length / questionsPerPage) || 1}
//         </span>
        
//         <button 
//           className="btn fw-bold px-3 py-2 d-flex align-items-center justify-content-center transition-all" 
//           onClick={() => paginate(currentPage < Math.ceil(submittedQuestions.length / questionsPerPage) ? currentPage + 1 : currentPage)} 
//           disabled={currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0}
//           style={{ 
//             borderRadius: '10px', 
//             backgroundColor: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? '#e9ecef' : '#ffffff', 
//             color: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? '#adb5bd' : colors.blue, 
//             border: '1px solid rgba(47, 49, 148, 0.08)',
//             fontSize: '12px',
//             cursor: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? 'not-allowed' : 'pointer',
//             boxShadow: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? 'none' : '0 4px 12px rgba(0,0,0,0.02)'
//           }}
//         >
//           Next
//         </button>
//       </div>

//       <footer style={{ position: 'fixed', left: '0', bottom: '0', width: '100%', padding: '20px 0', backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', zIndex: '1000', }}>
//         <p>© 2025 Quizifyai. All rights reserved.</p>
//       </footer>

//       {/* SCHEDULE QUIZ MODAL */}
// {showScheduleModal && (
//   <div 
//     style={{
//       position: 'fixed',
//       inset: 0,
//       backgroundColor: 'rgba(11, 12, 38, 0.75)',
//       backdropFilter: 'blur(8px)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 9999,
//       padding: '20px'
//     }}
//     onClick={() => setShowScheduleModal(false)}
//   >
//     <div 
//       style={{
//         backgroundColor: '#ffffff',
//         borderRadius: '20px',
//         maxWidth: '480px',
//         width: '100%',
//         padding: '28px',
//         boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
//         position: 'relative'
//       }}
//       onClick={(e) => e.stopPropagation()}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h5 className="fw-bold m-0" style={{ color: colors.blue }}>
//           📅 Schedule Live Quiz Session
//         </h5>
//         <button 
//           onClick={() => setShowScheduleModal(false)}
//           style={{ background: 'none', border: 'none', fontSize: '20px', color: '#94a3b8', cursor: 'pointer' }}
//         >
//           ✕
//         </button>
//       </div>

//       {!createdSchedulePin ? (
//         <form onSubmit={handleCreateSchedule}>
//           <p className="text-muted small mb-3">
//             Set an upcoming date and time. A unique 6-digit PIN will be generated for participants to register early.
//           </p>

//           <div className="mb-3">
//             <label className="form-label small fw-bold">Session Title / Topic</label>
//             <input 
//               type="text" 
//               className="form-control" 
//               placeholder="e.g. Batch"
//               value={scheduleTitle}
//               onChange={(e) => setScheduleTitle(e.target.value)}
//             />
//           </div>

//           <div className="row g-2 mb-3">
//             <div className="col-6">
//               <label className="form-label small fw-bold">Date *</label>
//               <input 
//                 type="date" 
//                 className="form-control" 
//                 required 
//                 value={scheduleDate}
//                 onChange={(e) => setScheduleDate(e.target.value)}
//               />
//             </div>
//             <div className="col-6">
//               <label className="form-label small fw-bold">Time *</label>
//               <input 
//                 type="time" 
//                 className="form-control" 
//                 required 
//                 value={scheduleTime}
//                 onChange={(e) => setScheduleTime(e.target.value)}
//               />
//             </div>
//           </div>

//           <button 
//             type="submit" 
//             disabled={schedulingLoading}
//             className="btn w-100 fw-bold py-2 text-white" 
//             style={{ backgroundColor: colors.orange, borderRadius: '10px' }}
//           >
//             {schedulingLoading ? 'Generating Schedule PIN...' : 'Confirm & Generate Schedule'}
//           </button>
//         </form>
//       ) : (
//         <div className="text-center py-2">
//           <div style={{ fontSize: '48px', marginBottom: '8px' }}>🎉</div>
//           <h5 className="fw-bold text-success mb-1">Session Scheduled!</h5>
//           <p className="text-muted small mb-3">Share this PIN or link with your participants:</p>

//           <div 
//             className="py-3 px-4 rounded-3 mb-3 d-inline-block" 
//             style={{ backgroundColor: '#f1f5f9', border: '2px dashed #0284c7', fontSize: '32px', fontWeight: '800', letterSpacing: '4px', color: colors.blue }}
//           >
//             {createdSchedulePin}
//           </div>

//           {/* <div className="p-2 rounded bg-light mb-3">
//             <code style={{ fontSize: '11px', wordBreak: 'break-all' }}>
//               {`${window.location.origin}/join?pin=${createdSchedulePin}`}
//             </code>
//           </div> */}
//           <div className="p-2 rounded bg-light mb-3">
//             <code style={{ fontSize: '11px', wordBreak: 'break-all' }}>
//               {`${window.location.origin}/join?pin=${createdSchedulePin}${createdScheduleEventId ? `&eventId=${createdScheduleEventId}` : ''}`}
//             </code>
//           </div>

//           <button 
//             onClick={() => setShowScheduleModal(false)}
//             className="btn btn-secondary w-100 fw-bold"
//             style={{ borderRadius: '10px' }}
//           >
//             Done
//           </button>
//         </div>
//       )}
//     </div>
//   </div>
// )}

//     </div>
//   );
// };

// export default QuestionnaireForm;




import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import axios from 'axios';

const QuestionnaireForm = () => {
  const [questions, setQuestions] = useState([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '', time: 1 },]);
  const [submittedQuestions, setSubmittedQuestions] = useState([]);
  const [editingQuestionId, setEditingQuestionId] = useState(null);
  const [showModal1, setShowModal1] = useState(false);
  const [showQuizimg, setShowQuizimg] = useState(false)
  const [user, setUser] = useState(null);
  const [events, setEvents] = useState([]);



  // --- Schedule Modal States ---
const [showScheduleModal, setShowScheduleModal] = useState(false);
const [scheduleDate, setScheduleDate] = useState('');
const [scheduleTime, setScheduleTime] = useState('');
const [scheduleTitle, setScheduleTitle] = useState('');
const [createdSchedulePin, setCreatedSchedulePin] = useState(null);
const [schedulingLoading, setSchedulingLoading] = useState(false);
const [createdScheduleEventId, setCreatedScheduleEventId] = useState(null);


const [expiresAtDate, setExpiresAtDate] = useState('');
const [expiresAtTime, setExpiresAtTime] = useState('');
const [activeExpiresAt, setActiveExpiresAt] = useState(null);

// --- Generation Mode States (Text Topic vs PDF Upload) ---
const [genMode, setGenMode] = useState('text'); // 'text' | 'pdf'
const [pdfFile, setPdfFile] = useState(null);

// --- Self-Paced Quiz Modal States ---
const [showSelfPacedModal, setShowSelfPacedModal] = useState(false);
const [selfPacedTitle, setSelfPacedTitle] = useState('');
const [secondsPerQuestion, setSecondsPerQuestion] = useState(30);
const [createdSelfPacedCode, setCreatedSelfPacedCode] = useState(null);
const [selfPacedLoading, setSelfPacedLoading] = useState(false);

  // --- Quota & Subscription Lock States ---
  const [subStatus, setSubStatus] = useState(null);

  const fetchSubStatus = async (userId) => {
    try {
      const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/subscription/current-status/${userId}`);
      if (res.data?.success) {
        setSubStatus(res.data);
      }
    } catch (err) {
      console.error('Failed to load subscription status:', err);
    }
  };

  useEffect(() => {
    if (user?.id) {
      fetchSubStatus(user.id);
    }
  }, [user]);


// --- UNIFIED SUBSCRIPTION & EVENT LOCK LOGIC ---
  const activeEvent = events.find((event) => event.flag === 1);
  const isEventLocked = activeEvent?.is_locked === 1;

  // 1. Subscription Check (Expired Trial, Expired Paid Plan, or Quota Exhausted)
  const isSubscriptionLocked = (() => {
    if (!subStatus) return false;
    const isExpired = subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired';
    const isExhausted = subStatus.quizzesRemaining <= 0;
    return isExpired || isExhausted;
  })();

  // 2. Action Lock: Disable adding/editing/generating if subscription is locked OR event is completed/locked
  const isActionDisabled = isSubscriptionLocked || isEventLocked;

  // 3. Hosting/Scheduling Lock: If trial or paid plan is expired, lock hosting too!
  const isHostingLocked = (() => {
    if (!subStatus) return false;
    return subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired';
  })();

  const getCombinedLockReason = () => {
    if (isEventLocked) {
      return 'Event Quiz Completed & Locked: Questions cannot be altered or added for this event.';
    }
    if (!subStatus) return '';
    if (subStatus.planStatus === 'trial_expired') {
      return '7-Day Free Free Trial Expired: Upgrade your plan to edit or host quizzes.';
    }
    if (subStatus.planStatus === 'expired') {
      return 'Subscription Expired: Please renew your plan to continue.';
    }
    if (subStatus.quizzesRemaining <= 0) {
      return `Quota Reached: All ${subStatus.allowedQuizzes} Event Quizzes used. Upgrade or renew to add more.`;
    }
    return '';
  };



  const colors = {
    orange: '#f35018',
    blue: '#2f3194',
    cyan: '#63decc',
    textMain: '#0f1137',
    glassWhite: 'rgba(255, 255, 255, 0.85)'
  };

  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);


  useEffect(() => {
    if (user && events.length > 0) {
      fetchData();
    }
  }, [user, events]);

  const fetchData = () => {
    if (user && user.id) {
      const activeEvent = events.find((event) => event.flag === 1);
      const eventId = activeEvent ? activeEvent.id : null;
      let url = `https://rvapi.emedha.in/pages/api/api/questions?userId=${user.id}`;
      if (eventId) {
        url += `&eventId=${eventId}`;
      }
      fetch(url)
        .then((response) => response.json())
        .then((data) => setSubmittedQuestions(data))
        .catch((error) => console.error('Error fetching questions:', error));
    }
  };


  const handleCreateSchedule = async (e) => {
  e.preventDefault();
  if (!scheduleDate || !scheduleTime) {
    alert('Please select both Date and Time.');
    return;
  }

  const activeEvent = events.find((event) => event.flag === 1);
  const eventId = activeEvent ? activeEvent.id : null;

  if (!eventId || !user?.id) {
    alert('Active event or user session not found.');
    return;
  }

  // Combine into MySQL DATETIME format (YYYY-MM-DD HH:MM:SS)
  const scheduledAt = `${scheduleDate} ${scheduleTime}:00`;

  try {
    setSchedulingLoading(true);
    const res = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/schedule-session', {
      eventId,
      userId: user.id,
      scheduledAt,
      title: scheduleTitle || activeEvent.name
    });

    if (res.data.success) {
      setCreatedSchedulePin(res.data.roomPin);
      setCreatedScheduleEventId(eventId)
    }
  } catch (err) {
    console.error('Failed to schedule session:', err);
    alert(err.response?.data?.error || 'Failed to schedule quiz.');
  } finally {
    setSchedulingLoading(false);
  }
};


  const handleInputChange = (e, index, field, optionIndex = null) => {
    const { value } = e.target;
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      if (field === 'title') {
        updatedQuestions[index].title = value;
      } else if (field === 'question') {
        updatedQuestions[index].question = value;
      } else if (field === 'option') {
        updatedQuestions[index].options[optionIndex] = value;
      } else if (field === 'correctAnswer') {
        updatedQuestions[index].correctAnswer = value;
      } else if (field === 'correct_image') {
        updatedQuestions[index].correct_image = value;
      } else if (field === 'time') {
        const parsedTime = parseInt(value, 10);
        console.log('Time changed to:', parsedTime);
        updatedQuestions[index].time = parsedTime;
      }
      return updatedQuestions;
    });
  };



  const handleSubmit = (e) => {

    const activeEvent = events.find((event) => event.flag === 1);
    const eventId = activeEvent ? activeEvent.id : null;

    console.log('Submitting time:', questions[0].time);
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', questions[0].title);
    formData.append('question', questions[0].question);
    formData.append('correctAnswer', questions[0].correctAnswer);
    formData.append('correct_image', questions[0].correct_image);
    formData.append('userId', user ? user.id : null);
    formData.append('time', questions[0].time);
    formData.append('event_id', eventId);
    questions[0].options.forEach((option, index) => {
      formData.append(`options[${index}]`, option);
    });
    if (showQuizimg) {
      for (let index = 0; index < 4; index++) {
        const inputElement = document.querySelector(`#fileInput${index}`);
        if (inputElement && inputElement.files.length > 0) {
          formData.append('files', inputElement.files[0]);
        }
      }
    }

    const url = editingQuestionId
      ? `https://rvapi.emedha.in/pages/api/api/questions/${editingQuestionId}`
      : `https://rvapi.emedha.in/pages/api/api/questions`;

    fetch(url, {
      method: editingQuestionId ? 'PUT' : 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === 'Question inserted successfully' || data.message === 'Question updated successfully') {
          alert('Your question has been successfully submitted!');
          fetchData();
    if (user?.id) fetchSubStatus(user.id);
        } else {
          alert(data.message || 'There was an error submitting the question. Please try again.');
        }
        setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '', time: 1 }]);
        setShowModal1(false);
        setShowQuizimg(false);
      })
      .catch((error) => {
        alert('Error submitting question: ' + error.message);
        console.error('Error submitting question:', error);
      });
  };

  const handleEdit = (questionId) => {
    const questionToEdit = submittedQuestions.find((q) => q.id === questionId);
    setEditingQuestionId(questionId);
    setQuestions([
      {
        title: questionToEdit.title,
        question: questionToEdit.question,
        options: [
          questionToEdit.option_1,
          questionToEdit.option_2,
          questionToEdit.option_3,
          questionToEdit.option_4,
        ],
        correctAnswer: questionToEdit.correct_answer,
        correct_image: questionToEdit.correct_image,
        images1: questionToEdit.images1,
        images2: questionToEdit.images2,
        images3: questionToEdit.images3,
        images4: questionToEdit.images4,
        time: questionToEdit.time,
      },
    ]);


    if (questionToEdit.images1 || questionToEdit.images2 || questionToEdit.images3 || questionToEdit.images4) {
      setShowQuizimg(true);
      setShowModal1(false);
    } else {
      setShowModal1(true);
      setShowQuizimg(false);
    }
  };

  const handleDelete = (questionId) => {
    fetch(`https://rvapi.emedha.in/pages/api/api/questions/${questionId}`, {
      method: 'DELETE',
    }).then((response) => response.json())
      .then(() => {
        setSubmittedQuestions((prevQuestions) =>
          prevQuestions.filter((q) => q.id !== questionId)
        );
      })
      .catch((error) => console.error('Error deleting question:', error));
  };
  const navigate = useNavigate();
  const handleBack = () => { navigate(-1); };


  const handleGenerateUrl = () => {
    const randomString = Math.random().toString(36).substring(2, 100);
    navigate(`/QuestionsList/${user.id}/${randomString}/QuestionsList`);
  };
  const handleWithoutGenerateUrl = () => {
    const randomString = Math.random().toString(36).substring(2, 100);
    navigate(`/QuestionsList/${user.id}/${randomString}/QuestionsList1`);
  };


  // Updated Host Live Room launcher engine
  // const handleLaunchLiveSession = (requiresCertificate) => {
  //   if (!user || !user.id) {
  //     alert("Session expired. Please log in again.");
  //     return;
  //   }

  //   // Identify the active event profile
  //   const activeEvent = events.find((event) => event.flag === 1);
  //   const eventId = activeEvent ? activeEvent.id : 'no-event';

  //   // Generate a secure, unique 6-digit numeric game PIN
  //   const generatedPin = Math.floor(100000 + Math.random() * 900000).toString();

  //   // Create the exact direct link your participants will scan to join
  //   const participantJoinUrl = `${window.location.origin}/join?pin=${generatedPin}&eventId=${eventId}`;

  //   // Pass the parameters cleanly via React Router State to the Host view
  //   navigate(`/HostLiveRoom/${generatedPin}`, {
  //     state: {
  //       pin: generatedPin,
  //       eventId: eventId,
  //       joinUrl: participantJoinUrl,
  //       certMode: requiresCertificate,
  //       userId: user.id
  //     }
  //   });
  // };


  const handleLaunchLiveSession = async (requiresCertificate) => {
  if (!user || !user.id) {
    alert("Session expired. Please log in again.");
    return;
  }

  // 1. Identify active event
  const activeEvent = events.find((event) => event.flag === 1);
  const eventId = activeEvent ? activeEvent.id : null;

  if (!eventId) {
    alert("No active event selected at the header layer.");
    return;
  }

  // 2. Generate the unique 6-digit PIN
  const generatedPin = Math.floor(100000 + Math.random() * 900000).toString();
  const participantJoinUrl = `${window.location.origin}/join?pin=${generatedPin}&eventId=${eventId}`;

  try {
    // 3. HIT BACKEND API TO WRITE PIN TO quiz_active_sessions TABLE
    const response = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/create-session', {
      roomPin: generatedPin,
      eventId: eventId,
      userId: user.id
    });

    if (response.data.success) {
      // 4. Navigate only if database write was successful
      navigate(`/HostLiveRoom/${generatedPin}`, {
        state: {
          pin: generatedPin,
          eventId: eventId,
          joinUrl: participantJoinUrl,
          certMode: requiresCertificate,
          userId: user.id
        }
      });
    }
  } catch (error) {
    console.error("API error establishing room:", error);
    alert("Failed to initialize the live database room. Try again.");
  }
};

  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
    } else {
      console.log('No user data found in session storage');
    }
  }, []);

  useEffect(() => {
    if (user && user.id) {
      fetchEvents();
    } else {
      console.log('User is missing or incomplete');
    }
  }, [user]);
  const fetchEvents = async () => {
    if (!user || !user.id) {
      console.error('User ID is missing');
      return;
    }
    try {
      const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
      setEvents(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 10;
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestions = submittedQuestions.slice(indexOfFirstQuestion, indexOfLastQuestion);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate gpt

  const [topicx, setTopicx] = useState('');
  const [loading, setLoading] = useState(false);
  const [numQuestions, setNumQuestions] = useState(5);

  // const handleGenerateQuiz = async () => {
  //   setLoading(true);
  //   try {
  //     if (!user) {
  //       console.error('User not found or not logged in');
  //       return;
  //     }
  //     if (!topicx.trim()) {
  //       console.error('Topic is empty');
  //       return;
  //     }
  //     const activeEvent = events.find((event) => event.flag === 1);
  //     const eventId = activeEvent ? activeEvent.id : null;

  //     const response = await axios.post('https://rvapi.emedha.in/pages/api/generate-quiz', {
  //       prompt: topicx,
  //       numberOfQuestions: numQuestions,
  //       model: 'text-davinci-003',
  //       max_tokens: 300,
  //       user: user.id,
  //       event_id: eventId,
  //     });

  //     const data = response.data;
  //     console.log('API Response:', data);
  //     const questionData = data.questionsx || [];
  //     const parsedQuestions = questionData
  //       .filter(q => q.question.trim() !== '')
  //       .map((q, index) => ({
  //         question: q.question,
  //         options: q.options || ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
  //         correctAnswer: q.correctAnswer || 'A',
  //       }));
  //     setSubmittedQuestions(parsedQuestions);
  //     fetchData();
  //     if (user?.id) fetchSubStatus(user.id);
  //   }  catch (error) {
  //     console.error('Error generating quiz:', error);
  //     alert(error.response?.data?.message || error.response?.data || 'Failed to generate quiz. Check your plan quota.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };


const handleGenerateQuiz = async () => {
  if (!user) {
    alert('User not logged in');
    return;
  }

  if (genMode === 'text' && !topicx.trim()) {
    alert('Please enter a topic name.');
    return;
  }

  if (genMode === 'pdf' && !pdfFile) {
    alert('Please upload a PDF file.');
    return;
  }

  const activeEvent = events.find((event) => event.flag === 1);
  const eventId = activeEvent ? activeEvent.id : null;

  setLoading(true);
  try {
    const formData = new FormData();
    formData.append('user', user.id);
    formData.append('numberOfQuestions', numQuestions);
    formData.append('event_id', eventId);

    if (genMode === 'pdf') {
      formData.append('pdfFile', pdfFile);
      formData.append('prompt', pdfFile.name.replace(/\.[^/.]+$/, ''));
    } else {
      formData.append('prompt', topicx.trim());
    }

    const response = await axios.post('https://rvapi.emedha.in/pages/api/generate-quiz', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    alert(response.data.message || 'Quiz generated successfully!');
    fetchData();
    if (user?.id) fetchSubStatus(user.id);
  } catch (error) {
    console.error('Error generating quiz:', error);
    alert(error.response?.data?.message || error.response?.data || 'Failed to generate quiz.');
  } finally {
    setLoading(false);
  }
};
  

// const handleCreateSelfPaced = async (e) => {
//   e.preventDefault();
//   const activeEvent = events.find((event) => event.flag === 1);
//   const eventId = activeEvent ? activeEvent.id : null;

//   if (!eventId || !user?.id) {
//     alert('Active event or user session not found.');
//     return;
//   }

//   try {
//     setSelfPacedLoading(true);
//     const res = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/create-self-paced', {
//       eventId,
//       userId: user.id,
//       title: selfPacedTitle || activeEvent.name,
//       secondsPerQuestion: parseInt(secondsPerQuestion) || 60
//     });

//     if (res.data.success) {
//       setCreatedSelfPacedCode(res.data.quizCode);
//     }
//   } catch (err) {
//     console.error('Failed to create self-paced quiz:', err);
//     alert(err.response?.data?.error || 'Failed to generate link.');
//   } finally {
//     setSelfPacedLoading(false);
//   }
// };

const handleCreateSelfPaced = async (e) => {
  e.preventDefault();
  const activeEvent = events.find((event) => event.flag === 1);
  const eventId = activeEvent ? activeEvent.id : null;

  if (!eventId || !user?.id) {
    alert('Active event or user session not found.');
    return;
  }

  if (!expiresAtDate || !expiresAtTime) {
    alert('Please specify an expiration date and time.');
    return;
  }

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  const expiresAt = `${expiresAtDate} ${expiresAtTime}:00`;

  if (new Date(expiresAt) <= new Date()) {
    alert('Expiration time must be set in the future.');
    return;
  }

  try {
    setSelfPacedLoading(true);
    const res = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/create-self-paced', {
      eventId,
      userId: user.id,
      title: selfPacedTitle || activeEvent.name,
      secondsPerQuestion: parseInt(secondsPerQuestion) || 60,
      expiresAt
    });

    if (res.data.success) {
      setCreatedSelfPacedCode(res.data.quizCode);
      setActiveExpiresAt(res.data.expiresAt);
    }
  } catch (err) {
    console.error('Failed to create self-paced quiz:', err);
    if (err.response?.data?.alreadyActive) {
      alert(err.response.data.error);
      // Display the existing active link and expiration info
      setCreatedSelfPacedCode(err.response.data.quizCode);
      setActiveExpiresAt(err.response.data.expiresAt);
    } else {
      alert(err.response?.data?.error || 'Failed to generate link.');
    }
  } finally {
    setSelfPacedLoading(false);
  }
};



const handleOpenSelfPacedModal = async () => {
  if (isHostingLocked) {
    alert(getCombinedLockReason());
    return;
  }

  const activeEvent = events.find((event) => event.flag === 1);
  const eventId = activeEvent ? activeEvent.id : null;

  if (!eventId || !user?.id) {
    alert("Please select an active event first.");
    return;
  }

  try {
    setSelfPacedLoading(true);
    // Check if an unexpired link already exists
    const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/active-self-paced/${eventId}/${user.id}`);

    if (res.data?.hasActive) {
      // 1. Unexpired link exists: Show code, URL, and copy button immediately
      setCreatedSelfPacedCode(res.data.quizCode);
      setActiveExpiresAt(res.data.expiresAt);
      setSelfPacedTitle(res.data.title || '');
      setSecondsPerQuestion(res.data.secondsPerQuestion || 60);
    } else {
      // 2. No link exists OR link has expired: Reset and show creation form
      setCreatedSelfPacedCode(null);
      setActiveExpiresAt(null);
      setSelfPacedTitle('');
      setSecondsPerQuestion(60);
      setExpiresAtDate('');
      setExpiresAtTime('');
    }

    setShowSelfPacedModal(true);
  } catch (err) {
    console.error("Error checking active self-paced quiz:", err);
    // Fallback: open form
    setCreatedSelfPacedCode(null);
    setShowSelfPacedModal(true);
  } finally {
    setSelfPacedLoading(false);
  }
};

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', fontSize: '12px', background: '#eaf3fcff', }}>

    <div style={{ 
      background: 'linear-gradient(135deg, #f4f5fc 0%, #eef0fa 100%)', 
      fontFamily: '"Plus Jakarta Sans", "Poppins", sans-serif', 
      padding: '10px 10px', 
      fontSize: '12px',

      color: colors.textMain
    }}>
      
      {/* LUXURY DYNAMIC EVENT HEADER */}
      <div className="header mb-4" style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        padding: '16px 24px', 
        backgroundColor: colors.glassWhite,
        backdropFilter: 'blur(20px)',
        borderRadius: '16px', 
        border: '1px solid rgba(255, 255, 255, 0.7)',
        boxShadow: '0 10px 30px rgba(15, 17, 55, 0.03)', 
      }}>
   <div
  className="d-flex align-items-center position-relative"
  style={{ width: "100%" }}
>
  <div
    style={{
      padding: "2px",
      background: `linear-gradient(135deg, ${colors.blue}, ${colors.cyan})`,
      borderRadius: "8px",
      zIndex: 2,
    }}
  >
    <img
      src={events.find((event) => event.flag === 1)?.file || ""}
      alt="Logo"
      style={{
        width: "56px",
        height: "56px",
        objectFit: "contain",
        borderRadius: "6px",
        backgroundColor: "#fff",
      }}
    />
  </div>

  <h2
    className="mb-0 fw-bold text-truncate"
    style={{
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      color: colors.white,
      fontSize: "25px",
      letterSpacing: "0.2px",
      textAlign: "center",
      width: "100%",
      pointerEvents: "none",
    }}
  >
    {events && events.length > 0
      ? events.find((e) => e.flag === 1)?.name
      : "No active session"}
  </h2>
</div>
      </div>


      {/* LUXURY ACTION CONTROL MATRIX */}
      <div className="mb-1 p-4" style={{ 
        backgroundColor: '#ffffff', 
        borderRadius: '20px',
        boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)',
        border: '1px solid rgba(47, 49, 148, 0.05)'
      }}>
        <div className="container-fluid p-0">
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
            
            {/* Back Navigation Title */}
            <div className="d-flex align-items-center gap-2">
              <IoArrowBackCircle 
                onClick={handleBack} 
                style={{ cursor: 'pointer', fontSize: '2.2rem', color: colors.blue, transition: 'all 0.2s ease' }} 
                onMouseEnter={(e) => e.currentTarget.style.color = colors.orange}
                onMouseLeave={(e) => e.currentTarget.style.color = colors.blue}
              />
              <div>
                <h4 className="m-0 fw-bold" style={{ color: colors.blue, letterSpacing: '-0.5px' }}>Quiz Management</h4>
                <p className="text-muted mb-0" style={{ fontSize: '11px' }}>Build custom question banks or leverage AI setups.</p>
              </div>
            </div>
            
            {/* Premium Button Suite */}
            {/* <div className="d-flex flex-wrap gap-2 justify-content-center">
           

              <button 
                className="btn btn-sm fw-bold px-3 py-2 transition-all" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  if (isCreationLocked) {
                    alert(getLockReason());
                    return;
                  }
                  setShowModal1(true); 
                  setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
                }} 
                disabled={isCreationLocked}
                style={{ 
                  borderRadius: '10px', 
                  backgroundColor: isCreationLocked ? '#9ca3af' : colors.blue, 
                  color: '#fff', 
                  border: 'none', 
                  boxShadow: isCreationLocked ? 'none' : '0 4px 12px rgba(47,49,148,0.15)',
                  cursor: isCreationLocked ? 'not-allowed' : 'pointer',
                  opacity: isCreationLocked ? 0.65 : 1
                }}
                title={isCreationLocked ? getLockReason() : "Add Quiz"}
              >
                + Add Quiz
              </button>


              <button 
                className="btn btn-sm fw-bold px-3 py-2 transition-all" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  if (isCreationLocked) {
                    alert(getLockReason());
                    return;
                  }
                  setShowQuizimg(true); 
                  setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
                }} 
                disabled={isCreationLocked}
                style={{ 
                  borderRadius: '10px', 
                  backgroundColor: '#ffffff', 
                  color: isCreationLocked ? '#9ca3af' : colors.blue, 
                  border: `1px solid ${isCreationLocked ? '#d1d5db' : 'rgba(47,49,148,0.15)'}`, 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.02)',
                  cursor: isCreationLocked ? 'not-allowed' : 'pointer',
                  opacity: isCreationLocked ? 0.65 : 1
                }}
                title={isCreationLocked ? getLockReason() : "Add Images Quiz"}
              >
                + Add Images Quiz
              </button>
<button 
  className="btn btn-sm fw-bold px-3 py-2 transition-all" 
  onClick={() => handleLaunchLiveSession(false)} 
  style={{ borderRadius: '10px', backgroundColor: 'rgba(15, 17, 55, 0.05)', color: colors.textMain, border: 'none' }}
>
  🎮 Host Live 
</button>


<button 
  className="btn btn-sm fw-bold px-3 py-2 transition-all" 
  onClick={() => {
    setCreatedSchedulePin(null);
    setScheduleDate('');
    setScheduleTime('');
    setScheduleTitle('');
    setShowScheduleModal(true);
  }} 
  style={{ 
    borderRadius: '10px', 
    backgroundColor: '#ffffff', 
    color: colors.blue, 
    border: `1.5px solid ${colors.blue}`,
    boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
  }}
>
  📅 Schedule Quiz
</button>

{/* <button 
  className="btn btn-sm fw-bold px-3 py-2 transition-all" 
  onClick={() => handleLaunchLiveSession(true)} 
  style={{ borderRadius: '10px', background: `linear-gradient(135deg, ${colors.orange}, #ff7342)`, color: '#fff', border: 'none', boxShadow: '0 4px 12px rgba(243,80,24,0.15)' }}
>
  🏆 Host Live (With Cert)
</button>
   
         </div>  */}

<div className="d-flex flex-wrap gap-2 justify-content-center align-items-center">
              
              {/* Event Locked Indicator Badge */}
              {isEventLocked && (
                <span className="badge bg-danger px-3 py-2 rounded-pill me-1" style={{ fontSize: '11px' }}>
                  🔒 Event Locked (Podium Finished)
                </span>
              )}

              {/* 1. Add Quiz */}
              <button 
                className="btn btn-sm fw-bold px-3 py-2" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  if (isActionDisabled) {
                    alert(getCombinedLockReason());
                    return;
                  }
                  setShowModal1(true); 
                  setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
                }} 
                disabled={isActionDisabled}
                style={{ 
                  borderRadius: '10px', 
                  backgroundColor: isActionDisabled ? '#9ca3af' : colors.blue, 
                  color: '#fff', 
                  border: 'none', 
                  cursor: isActionDisabled ? 'not-allowed' : 'pointer',
                  opacity: isActionDisabled ? 0.65 : 1
                }}
                title={isActionDisabled ? getCombinedLockReason() : "Add Quiz"}
              >
                + Add Quiz
              </button>

              {/* 2. Add Images Quiz */}
              <button 
                className="btn btn-sm fw-bold px-3 py-2" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  if (isActionDisabled) {
                    alert(getCombinedLockReason());
                    return;
                  }
                  setShowQuizimg(true); 
                  setQuestions([{ title: '', question: '', options: ['', '', '', ''], correctAnswer: '', correct_image: '' }]); 
                }} 
                disabled={isActionDisabled}
                style={{ 
                  borderRadius: '10px', 
                  backgroundColor: '#ffffff', 
                  color: isActionDisabled ? '#9ca3af' : colors.blue, 
                  border: `1px solid ${isActionDisabled ? '#d1d5db' : 'rgba(47,49,148,0.15)'}`, 
                  cursor: isActionDisabled ? 'not-allowed' : 'pointer',
                  opacity: isActionDisabled ? 0.65 : 1
                }}
                title={isActionDisabled ? getCombinedLockReason() : "Add Images Quiz"}
              >
                + Add Images Quiz
              </button>

              {/* 3. Host Live Button */}
              <button 
                className="btn btn-sm fw-bold px-3 py-2" 
                onClick={() => {
                  if (isHostingLocked) {
                    alert(getCombinedLockReason());
                    return;
                  }
                  handleLaunchLiveSession(false);
                }} 
                disabled={isHostingLocked}
                style={{ 
                  borderRadius: '10px', 
                  backgroundColor: isHostingLocked ? '#9ca3af' : 'rgba(15, 17, 55, 0.05)', 
                  color: isHostingLocked ? '#ffffff' : colors.textMain, 
                  border: 'none',
                  cursor: isHostingLocked ? 'not-allowed' : 'pointer',
                  opacity: isHostingLocked ? 0.65 : 1
                }}
                title={isHostingLocked ? getCombinedLockReason() : "Host Live"}
              >
                🎮 Host Live 
              </button>

              {/* 4. Schedule Quiz Button */}
              <button 
                className="btn btn-sm fw-bold px-3 py-2" 
                onClick={() => {
                  if (isHostingLocked) {
                    alert(getCombinedLockReason());
                    return;
                  }
                  setCreatedSchedulePin(null);
                  setCreatedScheduleEventId(null);
                  setScheduleDate('');
                  setScheduleTime('');
                  setScheduleTitle('');
                  setShowScheduleModal(true);
                }} 
                disabled={isHostingLocked}
                style={{ 
                  borderRadius: '10px', 
                  backgroundColor: '#ffffff', 
                  color: isHostingLocked ? '#9ca3af' : colors.blue, 
                  border: `1.5px solid ${isHostingLocked ? '#d1d5db' : colors.blue}`,
                  cursor: isHostingLocked ? 'not-allowed' : 'pointer',
                  opacity: isHostingLocked ? 0.65 : 1
                }}
                title={isHostingLocked ? getCombinedLockReason() : "Schedule Quiz"}
              >
                📅 Schedule Quiz
              </button>

         
{/* 5. Share Self-Paced Quiz Button */}
<button 
  className="btn btn-sm fw-bold px-3 py-2" 
  onClick={handleOpenSelfPacedModal}
  disabled={isHostingLocked}
  style={{ 
    borderRadius: '10px', 
    backgroundColor: '#ffffff', 
    color: '#0284c7', 
    border: '1.5px solid #0284c7',
    cursor: isHostingLocked ? 'not-allowed' : 'pointer',
    opacity: isHostingLocked ? 0.65 : 1
  }}
  title="Share an open link for participants to take independently anytime"
>
  ⚡ Share Self-Paced Quiz
</button>

            </div>


          </div>
        </div>
      </div>
      </div>
     {/* LUXURY GENERATIVE AI CAPABILITY SECTION */}
      {/* <div className="text-center mb-2" style={{  padding: '10px 10px', }}>
        <div className="d-flex mb-3 gap-3 flex-wrap align-items-center justify-content-center" style={{ 
          borderRadius: '24px', 
          backgroundColor: '#ffffff', 
          padding: '24px',
          boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)',
          border: '1px solid rgba(47, 49, 148, 0.05)'
        }}>
          
    
          <div className="col-12 col-md-5">
            <label className="d-block text-start mb-2 fw-bold text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>
              AI GENERATION TOPIC
            </label>
            <input 
              type="text" 
              className="form-control px-3 py-2" 
              value={topicx} 
              onChange={(e) => setTopicx(e.target.value)} 
              placeholder="Enter a topic (e.g., General Knowledge, Science)" 
              style={{ 
                borderRadius: '12px', 
                fontSize: '13px', 
                border: '1px solid rgba(47, 49, 148, 0.12)', 
                backgroundColor: '#f8f9fc',
                color: colors.textMain
              }} 
            />
          </div>

      
          <div className="col-12 col-md-3">
            <label className="d-block text-start mb-2 fw-bold text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>
              QUESTION QUANTITY
            </label>
            <input 
              type="number" 
              className="form-control px-3 py-2" 
              value={numQuestions} 
              min={1} 
              max={50} 
              onChange={(e) => setNumQuestions(Number(e.target.value))} 
              placeholder="Number of questions" 
              style={{ 
                borderRadius: '12px', 
                fontSize: '13px', 
                border: '1px solid rgba(47, 49, 148, 0.12)', 
                backgroundColor: '#f8f9fc',
                color: colors.textMain
              }} 
            />
          </div>

      
          <div className="col-12 col-md-3 d-grid pt-md-4">
          

         <button 
              className="btn fw-bold py-2 shadow-sm" 
              onClick={() => {
                if (isActionDisabled) {
                  alert(getCombinedLockReason());
                  return;
                }
                handleGenerateQuiz();
              }} 
              disabled={loading || !topicx.trim() || isActionDisabled} 
              style={{ 
                borderRadius: '12px',
                background: (loading || isActionDisabled) ? '#9ca3af' : `linear-gradient(135deg, ${colors.blue}, #4447ab)`,
                color: '#fff',
                border: 'none',
                fontSize: '13px',
                cursor: (loading || !topicx.trim() || isActionDisabled) ? 'not-allowed' : 'pointer',
                opacity: isActionDisabled ? 0.65 : 1
              }}
              title={isActionDisabled ? getCombinedLockReason() : "Generate AI Quiz"}
            >
              {loading 
                ? 'Generating Dynamic Assets...' 
                : isEventLocked 
                ? '🔒 Event Completed & Locked' 
                : isSubscriptionLocked 
                ? '🔒 Quota Reached / Plan Expired' 
                : '✨ Generate AI Quiz'}
            </button>
          </div>

        </div>
      </div> */}
{/* LUXURY GENERATIVE AI CAPABILITY SECTION (TOPIC OR PDF) */}
<div className="text-center mb-2" style={{ padding: '10px 10px' }}>
  <div style={{ 
    borderRadius: '24px', 
    backgroundColor: '#ffffff', 
    padding: '24px',
    boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)',
    border: '1px solid rgba(47, 49, 148, 0.05)'
  }}>
    
    {/* Mode Selector Tabs */}
    <div className="d-flex justify-content-center gap-2 mb-3">
      <button
        type="button"
        className={`btn btn-sm fw-bold px-3 py-1.5 rounded-pill ${genMode === 'text' ? 'btn-primary' : 'btn-light'}`}
        onClick={() => setGenMode('text')}
        style={{ fontSize: '12px' }}
      >
        ✍️ Enter Topic
      </button>
      <button
        type="button"
        className={`btn btn-sm fw-bold px-3 py-1.5 rounded-pill ${genMode === 'pdf' ? 'btn-primary' : 'btn-light'}`}
        onClick={() => setGenMode('pdf')}
        style={{ fontSize: '12px' }}
      >
        📄 Upload PDF Document
      </button>
    </div>

    <div className="d-flex mb-2 gap-3 flex-wrap align-items-center justify-content-center">
      {/* Dynamic input: Text or PDF */}
      <div className="col-12 col-md-5">
        <label className="d-block text-start mb-2 fw-bold text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>
          {genMode === 'pdf' ? 'DOCUMENT ATTACHMENT (.PDF)' : 'AI GENERATION TOPIC'}
        </label>
        
        {genMode === 'text' ? (
          <input 
            type="text" 
            className="form-control px-3 py-2" 
            value={topicx} 
            onChange={(e) => setTopicx(e.target.value)} 
            placeholder="Enter a topic (e.g., General Knowledge, Science)" 
            style={{ 
              borderRadius: '12px', 
              fontSize: '13px', 
              border: '1px solid rgba(47, 49, 148, 0.12)', 
              backgroundColor: '#f8f9fc',
              color: colors.textMain
            }} 
          />
        ) : (
          <input 
            type="file" 
            accept="application/pdf"
            className="form-control px-3 py-2" 
            onChange={(e) => setPdfFile(e.target.files[0])}
            style={{ 
              borderRadius: '12px', 
              fontSize: '13px', 
              border: '1px solid rgba(47, 49, 148, 0.12)', 
              backgroundColor: '#f8f9fc'
            }} 
          />
        )}
      </div>

      {/* Number of questions input wrapper */}
      <div className="col-12 col-md-3">
        <label className="d-block text-start mb-2 fw-bold text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>
          QUESTION QUANTITY
        </label>
        <input 
          type="number" 
          className="form-control px-3 py-2" 
          value={numQuestions} 
          min={1} 
          max={50} 
          onChange={(e) => setNumQuestions(Number(e.target.value))} 
          placeholder="Number of questions" 
          style={{ 
            borderRadius: '12px', 
            fontSize: '13px', 
            border: '1px solid rgba(47, 49, 148, 0.12)', 
            backgroundColor: '#f8f9fc',
            color: colors.textMain
          }} 
        />
      </div>

      {/* Interactive action trigger button */}
      <div className="col-12 col-md-3 d-grid pt-md-4">
        <button 
          className="btn fw-bold py-2 shadow-sm" 
          onClick={() => {
            if (isActionDisabled) {
              alert(getCombinedLockReason());
              return;
            }
            handleGenerateQuiz();
          }} 
          disabled={loading || isActionDisabled || (genMode === 'text' ? !topicx.trim() : !pdfFile)} 
          style={{ 
            borderRadius: '12px',
            background: (loading || isActionDisabled) ? '#9ca3af' : `linear-gradient(135deg, ${colors.blue}, #4447ab)`,
            color: '#fff',
            border: 'none',
            fontSize: '13px',
            cursor: (loading || isActionDisabled) ? 'not-allowed' : 'pointer',
            opacity: isActionDisabled ? 0.65 : 1
          }}
          title={isActionDisabled ? getCombinedLockReason() : "Generate AI Quiz"}
        >
          {loading 
            ? 'Analyzing & Generating...' 
            : isEventLocked 
            ? '🔒 Event Completed & Locked' 
            : isSubscriptionLocked 
            ? '🔒 Quota Reached / Plan Expired' 
            : genMode === 'pdf' ? '✨ Generate from PDF' : '✨ Generate AI Quiz'}
        </button>
      </div>
    </div>
  </div>
</div>

      <form onSubmit={handleSubmit}>
        {showModal1 && (
          <div className="modal" style={{ display: 'block', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)', fontSize: '10px', }}>
            <div className="modal-content" style={{ maxWidth: '600px', margin: '100px auto', backgroundColor: 'white', padding: '15px', borderRadius: '6px', }}>
              <div>
                {questions.map((question, index) => (
                  <div key={index} className="mb-3">
                    <div className="row mb-2">
                      <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Title:</label>
                      <div className="col-12">
                        <input type="text" value={question.title} onChange={(e) => handleInputChange(e, index, 'title')} placeholder="Enter your title" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Question:</label>
                        <input type="text" value={question.question} onChange={(e) => handleInputChange(e, index, 'question')} placeholder="Enter your question" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                      </div>
                      <div className="col-6">
                        <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Time (in minutes):</label>
                        <select required value={question.time || 1} onChange={(e) => handleInputChange(e, index, 'time')} style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }}>
                          {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
                            <option key={minute} value={minute}>
                              {minute} minute{minute > 1 ? 's' : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mb-2">
                      <label className="form-label" style={{ fontWeight: '600', color: '#333', marginBottom: '4px' }}>Options:</label>
                      <div className="row">
                        {question.options.map((option, optionIndex) => (
                          <div key={optionIndex} className="col-12 col-md-6 mb-2">
                            <input type="text" value={option} onChange={(e) => handleInputChange(e, index, 'option', optionIndex)} placeholder={`Option ${String.fromCharCode(65 + optionIndex)}`} required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-12 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Correct Answer:</label>
                      <div className="col-12">
                        <input type="text" value={question.correctAnswer} onChange={(e) => handleInputChange(e, index, 'correctAnswer')} placeholder="Enter correct answer" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                      </div>
                    </div>
                  </div>
                ))}

                <button type="submit" style={{ backgroundColor: '#28a745', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', marginBottom: '6px', }}>Submit</button>
                <button type="button" onClick={() => setShowModal1(false)} style={{ backgroundColor: '#dc3545', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', }}>Close</button>
              </div>
            </div>
          </div>
        )}
      </form>


      <form onSubmit={handleSubmit}>
        {showQuizimg && (
          <div className="modal" style={{ display: 'block', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.5)', fontSize: '10px', }}>
            <div className="modal-content" style={{ maxWidth: '600px', margin: '100px auto', backgroundColor: 'white', padding: '15px', borderRadius: '6px', }}>
              <div>
                {questions.map((question, index) => (
                  <div key={index} className="mb-3">
                    <div className="row mb-2">
                      <label className="col-12 col-md-2 col-form-label" style={{ fontWeight: '600', color: '#333' }}                   >Title:</label>
                      <div className="col-12">
                        <input type="text" value={question.title} onChange={(e) => handleInputChange(e, index, 'title')} placeholder="Enter your title" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Question:</label>
                        <input type="text" value={question.question} onChange={(e) => handleInputChange(e, index, 'question')} placeholder="Enter your question" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                      </div>
                      <div className="col-6">
                        <label className="col-form-label" style={{ fontWeight: '600', color: '#333' }}>Time (in minutes):</label>
                        <select required value={question.time || ''} onChange={(e) => handleInputChange(e, index, 'time')} style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }}>
                          {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
                            <option key={minute} value={minute}>
                              {minute} minute{minute > 1 ? 's' : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mb-2">
                      <label className="form-label" style={{ fontWeight: '600', marginBottom: '4px', color: '#333' }}>Options:</label>
                      <div className="row">
                        {question.options.map((option, optionIndex) => (
                          <div key={optionIndex} className="col-12 col-md-6 mb-2">
                            <label htmlFor={`fileInput${optionIndex}`} style={{ fontWeight: '500', color: '#333', fontSize: '12px' }}> {optionIndex + 1}.</label>
                            <input type="file" id={`fileInput${optionIndex}`} style={{ width: '100%', padding: '6px 8px', marginTop: '4px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                            {question[`images${optionIndex + 1}`] && (
                              <div>
                                <img src={question[`images${optionIndex + 1}`]} alt={`Option ${String.fromCharCode(65 + optionIndex)}`} style={{ height: '50px', marginTop: '6px' }} />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-12 col-form-label" style={{ fontWeight: '600', color: '#333' }}>Correct Answer Image No:</label>
                      <div className="col-12">
                        <input type="number" value={question.correct_image} onChange={(e) => handleInputChange(e, index, 'correct_image')} placeholder="Enter correct image No" required style={{ width: '100%', padding: '6px 8px', marginBottom: '6px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', }} />
                        {question.correct_image && (
                          <div><img src={question.correct_image} alt="Correct answer image" style={{ width: '100px', height: 'auto', marginTop: '6px' }} /></div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                <button type="submit" style={{ backgroundColor: '#28a745', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', marginBottom: '6px', }}>Submit</button>
                <button type="button" onClick={() => setShowQuizimg(false)} style={{ backgroundColor: '#dc3545', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', width: '100%', }}                >Close</button>
              </div>
            </div>
          </div>
        )}
      </form>

{/* 
      <div className="mt-2">
        <div style={{ background: '#fff', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '25px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ background: '#f5f5f5' }}>
                <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>#</th>
                <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Title</th>
                <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Question</th>
                <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Options</th>
                <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Correct Answer</th>
                <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {submittedQuestions.map((question, index) => (
                <tr key={index}>
                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{index + 1}</td>
                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{question.title}</td>
                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{question.question}</td>
                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
                    {['option_1', 'option_2', 'option_3', 'option_4'].map((optionKey, optionIndex) => {
                      const imageKey = `images${optionIndex + 1}`;
                      const imageUrl = question[imageKey];

                      if (imageUrl) {
                        return (
                          <div key={optionIndex} className="mb-1">
                            <img src={imageUrl} style={{ height: '50px', maxWidth: '100%' }} alt={`Option ${String.fromCharCode(65 + optionIndex)}`} />
                          </div>
                        );
                      } else if (question[optionKey]) {
                        return (
                          <div key={optionIndex} className="mb-1">
                            {String.fromCharCode(65 + optionIndex)}. {question[optionKey]}
                          </div>
                        );
                      }
                      return null;
                    })}
                  </td>

                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
                    {question.correct_answer && <div>{question.correct_answer}</div>}
                    {question.correct_image && (
                      <div> <img src={question.correct_image} alt="Correct answer image" style={{ width: '100px', height: 'auto', maxWidth: '100%' }} /></div>
                    )}
                  </td>

                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
                    <button onClick={() => handleEdit(question.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaEdit /></button>
                    <button onClick={() => handleDelete(question.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff', fontSize: '14px' }}><FaTrashAlt /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>


      <div className="pagination" style={{ textAlign: 'center', marginTop: '20px', marginBottom: '80px' }}>
        <button className="btn btn-secondary btn-sm" onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)} disabled={currentPage === 1}>Previous</button>
        <span style={{ margin: '0 10px' }}>Page {currentPage} of {Math.ceil(submittedQuestions.length / questionsPerPage)}</span>
        <button className="btn btn-secondary btn-sm" onClick={() => paginate(currentPage < Math.ceil(submittedQuestions.length / questionsPerPage) ? currentPage + 1 : currentPage)} disabled={currentPage === Math.ceil(submittedQuestions.length / questionsPerPage)}>Next</button>
      </div> */}
      {/* LUXURY RESPONSIVE DATA TABLE CONTAINER */}
      <div className="mt-4">
        <div style={{ 
          background: '#ffffff', 
          padding: '24px', 
          boxShadow: '0 10px 30px rgba(15, 17, 55, 0.02)', 
          borderRadius: '20px',
          border: '1px solid rgba(47, 49, 148, 0.05)',
          marginBottom: '30px' 
        }}>
          
          {/* Table Header Metrics */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
            <h5 className="fw-bold mb-0" style={{ color: colors.blue, fontSize: '16px', letterSpacing: '-0.3px' }}>
              Submitted Question Bank ({submittedQuestions.length})
            </h5>
            <span className="badge px-3 py-2 rounded-pill" style={{ backgroundColor: 'rgba(47,49,148,0.06)', color: colors.blue, fontSize: '11px', fontWeight: '600' }}>
              Active Track Records
            </span>
          </div>

          {/* Responsive Table Wrapper */}
          <div className="table-responsive">
            <table className="table table-borderless align-middle mb-0" style={{ fontSize: '13px', minWidth: '800px' }}>
              <thead>
                <tr style={{ background: '#f8f9fc', borderRadius: '12px' }}>
                  <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', width: '5%' }}>#</th>
                  <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '15%' }}>Title</th>
                  <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '30%' }}>Question</th>
                  <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '25%' }}>Options Configuration</th>
                  <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', width: '15%' }}>Target Answer</th>
                  <th style={{ padding: '14px 10px', color: '#6c757d', fontWeight: '700', borderTopRightRadius: '12px', borderBottomRightRadius: '12px', width: '10%', textAlign: 'center' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentQuestions.map((question, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid rgba(15, 17, 55, 0.04)' }}>
                    <td style={{ padding: '16px 10px', fontWeight: '600', color: colors.blue }}>
                      {indexOfFirstQuestion + index + 1}
                    </td>
                    <td style={{ padding: '16px 10px', fontWeight: '600', color: colors.textMain }}>
                      {question.title}
                    </td>
                    <td style={{ padding: '16px 10px', color: '#4a4d6d', lineHeight: '1.5' }}>
                      {question.question}
                    </td>
                    <td style={{ padding: '16px 10px' }}>
                      <div className="d-flex flex-column gap-1">
                        {['option_1', 'option_2', 'option_3', 'option_4'].map((optionKey, optionIndex) => {
                          const imageKey = `images${optionIndex + 1}`;
                          const imageUrl = question[imageKey];

                          if (imageUrl) {
                            return (
                              <div key={optionIndex} className="d-inline-block p-1 bg-light rounded" style={{ maxWidth: 'fit-content' }}>
                                <img src={imageUrl} style={{ height: '38px', borderRadius: '4px', objectFit: 'contain' }} alt={`Opt ${String.fromCharCode(65 + optionIndex)}`} />
                              </div>
                            );
                          } else if (question[optionKey]) {
                            return (
                              <div key={optionIndex} style={{ color: '#555875', fontSize: '12px' }}>
                                <strong style={{ color: colors.orange }}>{String.fromCharCode(65 + optionIndex)}:</strong> {question[optionKey]}
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    </td>
                    <td style={{ padding: '16px 10px' }}>
                      {question.correct_answer && (
                        <span className="badge px-2 py-1 rounded" style={{ backgroundColor: 'rgba(40, 167, 69, 0.1)', color: '#28a745', fontWeight: '600' }}>
                          {question.correct_answer}
                        </span>
                      )}
                      {question.correct_image && (
                        <div className="mt-1 p-1 d-inline-block bg-light rounded"> 
                          <img src={question.correct_image} alt="Correct target vector" style={{ width: '60px', height: 'auto', borderRadius: '4px' }} />
                        </div>
                      )}
                    </td>
                    {/*   <td style={{ padding: '16px 10px', textAlign: 'center' }}>
                      <div className="d-flex justify-content-center gap-2">
                        <button 
                          onClick={() => handleEdit(question.id)} 
                          className="btn p-2 rounded-3 d-flex align-items-center justify-content-center transition-all"
                          style={{ background: 'rgba(47, 49, 148, 0.05)', border: 'none', color: colors.blue }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = colors.blue; e.currentTarget.style.color = '#fff'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(47, 49, 148, 0.05)'; e.currentTarget.style.color = colors.blue; }}
                        >
                          <FaEdit size={14} />
                        </button>
                      <button 
                          onClick={() => handleDelete(question.id)} 
                          className="btn p-2 rounded-3 d-flex align-items-center justify-content-center transition-all"
                          style={{ background: 'rgba(243, 80, 24, 0.05)', border: 'none', color: colors.orange }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = colors.orange; e.currentTarget.style.color = '#fff'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(243, 80, 24, 0.05)'; e.currentTarget.style.color = colors.orange; }}
                        >
                          <FaTrashAlt size={14} />
                        </button> 
                      </div>
                    </td>*/}
                    <td style={{ padding: '16px 10px', textAlign: 'center' }}>
                      <div className="d-flex justify-content-center gap-2">
                        <button 
                          onClick={() => {
                            if (isEventLocked) {
                              alert("This event is locked because its quiz has already finished.");
                              return;
                            }
                            handleEdit(question.id);
                          }} 
                          disabled={isEventLocked}
                          className="btn p-2 rounded-3 d-flex align-items-center justify-content-center"
                          style={{ 
                            background: 'rgba(47, 49, 148, 0.05)', 
                            border: 'none', 
                            color: isEventLocked ? '#9ca3af' : colors.blue,
                            cursor: isEventLocked ? 'not-allowed' : 'pointer',
                            opacity: isEventLocked ? 0.5 : 1
                          }}
                          title={isEventLocked ? "Event is locked" : "Edit Question"}
                        >
                          <FaEdit size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      </div>

      {/* LUXURY INTERACTIVE PAGINATION CONTROLLER */}
      <div className="pagination d-flex align-items-center justify-content-center gap-3" style={{ marginTop: '10px', marginBottom: '100px' }}>
        <button 
          className="btn fw-bold px-3 py-2 d-flex align-items-center justify-content-center transition-all" 
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)} 
          disabled={currentPage === 1}
          style={{ 
            borderRadius: '10px', 
            backgroundColor: currentPage === 1 ? '#e9ecef' : '#ffffff', 
            color: currentPage === 1 ? '#adb5bd' : colors.blue, 
            border: '1px solid rgba(47, 49, 148, 0.08)',
            fontSize: '12px',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            boxShadow: currentPage === 1 ? 'none' : '0 4px 12px rgba(0,0,0,0.02)'
          }}
        >
          Previous
        </button>
        
        <span className="fw-semibold px-3 py-2 rounded-3" style={{ fontSize: '13px', backgroundColor: colors.glassWhite, color: colors.textMain, border: '1px solid rgba(47, 49, 148, 0.05)' }}>
          Page <strong style={{ color: colors.orange }}>{currentPage}</strong> of {Math.ceil(submittedQuestions.length / questionsPerPage) || 1}
        </span>
        
        <button 
          className="btn fw-bold px-3 py-2 d-flex align-items-center justify-content-center transition-all" 
          onClick={() => paginate(currentPage < Math.ceil(submittedQuestions.length / questionsPerPage) ? currentPage + 1 : currentPage)} 
          disabled={currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0}
          style={{ 
            borderRadius: '10px', 
            backgroundColor: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? '#e9ecef' : '#ffffff', 
            color: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? '#adb5bd' : colors.blue, 
            border: '1px solid rgba(47, 49, 148, 0.08)',
            fontSize: '12px',
            cursor: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? 'not-allowed' : 'pointer',
            boxShadow: (currentPage === Math.ceil(submittedQuestions.length / questionsPerPage) || submittedQuestions.length === 0) ? 'none' : '0 4px 12px rgba(0,0,0,0.02)'
          }}
        >
          Next
        </button>
      </div>

      <footer style={{ position: 'fixed', left: '0', bottom: '0', width: '100%', padding: '20px 0', backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', zIndex: '1000', }}>
        <p>© 2025 Quizifyai. All rights reserved.</p>
      </footer>

      {/* SCHEDULE QUIZ MODAL */}
{showScheduleModal && (
  <div 
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(11, 12, 38, 0.75)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}
    onClick={() => setShowScheduleModal(false)}
  >
    <div 
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        maxWidth: '480px',
        width: '100%',
        padding: '28px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
        position: 'relative'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold m-0" style={{ color: colors.blue }}>
          📅 Schedule Live Quiz Session
        </h5>
        <button 
          onClick={() => setShowScheduleModal(false)}
          style={{ background: 'none', border: 'none', fontSize: '20px', color: '#94a3b8', cursor: 'pointer' }}
        >
          ✕
        </button>
      </div>

      {!createdSchedulePin ? (
        <form onSubmit={handleCreateSchedule}>
          <p className="text-muted small mb-3">
            Set an upcoming date and time. A unique 6-digit PIN will be generated for participants to register early.
          </p>

          <div className="mb-3">
            <label className="form-label small fw-bold">Session Title / Topic</label>
            <input 
              type="text" 
              className="form-control" 
              placeholder="e.g. Batch"
              value={scheduleTitle}
              onChange={(e) => setScheduleTitle(e.target.value)}
            />
          </div>

          <div className="row g-2 mb-3">
            <div className="col-6">
              <label className="form-label small fw-bold">Date *</label>
              <input 
                type="date" 
                className="form-control" 
                required 
                value={scheduleDate}
                onChange={(e) => setScheduleDate(e.target.value)}
              />
            </div>
            <div className="col-6">
              <label className="form-label small fw-bold">Time *</label>
              <input 
                type="time" 
                className="form-control" 
                required 
                value={scheduleTime}
                onChange={(e) => setScheduleTime(e.target.value)}
              />
            </div>
          </div>

          <button 
            type="submit" 
            disabled={schedulingLoading}
            className="btn w-100 fw-bold py-2 text-white" 
            style={{ backgroundColor: colors.orange, borderRadius: '10px' }}
          >
            {schedulingLoading ? 'Generating Schedule PIN...' : 'Confirm & Generate Schedule'}
          </button>
        </form>
      ) : (
        <div className="text-center py-2">
          <div style={{ fontSize: '48px', marginBottom: '8px' }}>🎉</div>
          <h5 className="fw-bold text-success mb-1">Session Scheduled!</h5>
          <p className="text-muted small mb-3">Share this PIN or link with your participants:</p>

          <div 
            className="py-3 px-4 rounded-3 mb-3 d-inline-block" 
            style={{ backgroundColor: '#f1f5f9', border: '2px dashed #0284c7', fontSize: '32px', fontWeight: '800', letterSpacing: '4px', color: colors.blue }}
          >
            {createdSchedulePin}
          </div>

          {/* <div className="p-2 rounded bg-light mb-3">
            <code style={{ fontSize: '11px', wordBreak: 'break-all' }}>
              {`${window.location.origin}/join?pin=${createdSchedulePin}`}
            </code>
          </div> */}
          <div className="p-2 rounded bg-light mb-3">
            <code style={{ fontSize: '11px', wordBreak: 'break-all' }}>
              {`${window.location.origin}/join?pin=${createdSchedulePin}${createdScheduleEventId ? `&eventId=${createdScheduleEventId}` : ''}`}
            </code>
          </div>

          <button 
            onClick={() => setShowScheduleModal(false)}
            className="btn btn-secondary w-100 fw-bold"
            style={{ borderRadius: '10px' }}
          >
            Done
          </button>
        </div>
      )}
    </div>
  </div>
)}

{/* SELF-PACED QUIZ MODAL */}
{showSelfPacedModal && (
  <div 
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(11, 12, 38, 0.75)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}
    onClick={() => setShowSelfPacedModal(false)}
  >
    <div 
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        maxWidth: '480px',
        width: '100%',
        padding: '28px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
        position: 'relative'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold m-0" style={{ color: colors.blue }}>
          ⚡ Create Self-Paced Quiz Link
        </h5>
        <button 
          onClick={() => setShowSelfPacedModal(false)}
          style={{ background: 'none', border: 'none', fontSize: '20px', color: '#94a3b8', cursor: 'pointer' }}
        >
          ✕
        </button>
      </div>

      {!createdSelfPacedCode ? (
        <form onSubmit={handleCreateSelfPaced}>
          <p className="text-muted small mb-3">
            Generate an independent, link-accessible quiz. Set an expiration date; participants can take the quiz any time before it expires.
          </p>

          <div className="mb-3">
            <label className="form-label small fw-bold">Quiz Title</label>
            <input 
              type="text" 
              className="form-control" 
              placeholder="e.g. Assessment Quiz"
              value={selfPacedTitle}
              onChange={(e) => setSelfPacedTitle(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-bold">Seconds Per Question *</label>
            <input 
              type="number" 
              className="form-control" 
              min={10}
              max={300}
              required 
              value={secondsPerQuestion}
              onChange={(e) => setSecondsPerQuestion(e.target.value)}
            />
            <small className="text-muted">Timer allotted for each question during the session.</small>
          </div>

          {/* Expiration Date & Time */}
          <div className="row g-2 mb-3">
            <div className="col-6">
              <label className="form-label small fw-bold">Link Valid Until (Date) *</label>
              <input 
                type="date" 
                className="form-control" 
                required
                min={new Date().toISOString().split('T')[0]}
                value={expiresAtDate}
                onChange={(e) => setExpiresAtDate(e.target.value)}
              />
            </div>
            <div className="col-6">
              <label className="form-label small fw-bold">Valid Until (Time) *</label>
              <input 
                type="time" 
                className="form-control" 
                required
                value={expiresAtTime}
                onChange={(e) => setExpiresAtTime(e.target.value)}
              />
            </div>
          </div>

          <button 
            type="submit" 
            disabled={selfPacedLoading}
            className="btn w-100 fw-bold py-2 text-white" 
            style={{ backgroundColor: '#0284c7', borderRadius: '10px' }}
          >
            {selfPacedLoading ? 'Checking & Generating...' : 'Generate 8-Character Quiz Link'}
          </button>
        </form>
      ) : (
        <div className="text-center py-2">
          <div style={{ fontSize: '48px', marginBottom: '8px' }}>🚀</div>
          <h5 className="fw-bold text-success mb-1">Self-Paced Quiz Active!</h5>
          
          {activeExpiresAt && (
            <div className="alert alert-warning py-1.5 px-3 small my-2 d-inline-block rounded-pill">
              ⏳ Valid Until: <strong>{new Date(activeExpiresAt).toLocaleString()}</strong>
            </div>
          )}

          <p className="text-muted small mb-2">Anyone with this link can start the quiz before it expires:</p>

          <div 
            className="py-3 px-4 rounded-3 mb-3 d-inline-block" 
            style={{ backgroundColor: '#f0f9ff', border: '2px dashed #0284c7', fontSize: '30px', fontWeight: '800', letterSpacing: '4px', color: '#0284c7' }}
          >
            {createdSelfPacedCode}
          </div>

          <div className="p-2 rounded bg-light mb-3">
            <code style={{ fontSize: '11px', wordBreak: 'break-all' }}>
              {`${window.location.origin}/quiz/${createdSelfPacedCode}`}
            </code>
          </div>

          <button 
            onClick={() => {
              navigator.clipboard.writeText(`${window.location.origin}/quiz/${createdSelfPacedCode}`);
              alert('Copied link to clipboard!');
            }}
            className="btn btn-outline-primary w-100 fw-bold mb-2"
            style={{ borderRadius: '10px' }}
          >
            📋 Copy Quiz URL
          </button>

          <button 
            onClick={() => setShowSelfPacedModal(false)}
            className="btn btn-secondary w-100 fw-bold"
            style={{ borderRadius: '10px' }}
          >
            Done
          </button>
        </div>
      )}
    </div>
  </div>
)}
    </div>
  );
};

export default QuestionnaireForm;


